import type { Lang } from '../types';

export interface ApartmentDetailText {
  loading: string;
  loadingGuide: string;
  notFound: string;
  back: string;
  subtitle: string;
  savedSuccess: string;
  copySuccess: string;
  copyError: string;
  saving: string;
  saveChanges: string;
  deleteApartment: string;
  deleteApartmentDescription: string;
  // Tabs
  tabGeneral: string;
  tabContact: string;
  tabUbyport: string;
  tabCityTax: string;
  tabPayments: string;
  paymentsHeader: string;
  paymentsDesc: string;
  paymentsPurposeCityTax: string;
  paymentsPurposeCityTaxHint: string;
  paymentsPurposeUpsell: string;
  paymentsPurposeUpsellHint: string;
  paymentsPurposeDeposit: string;
  paymentsPurposeDepositHint: string;
  paymentsPurposeNotReady: string;
  paymentsNoneCityTax: string;
  paymentsNoneUpsell: string;
  paymentsNoneDeposit: string;
  paymentMethodInvalidError: string;
  cityTaxPaysToAccount: string;
  cityTaxNeedsAccount: string;
  cityTaxOpenPayments: string;
  tabCalendar: string;
  tabGuide: string;
  tabUpsell: string;
  tabDeposit: string;
  tabBooking: string;
  tabExport: string;
  // General tab
  fieldInternalName: string;
  fieldDisplayName: string;
  fieldAddress: string;
  fieldCapacity: string;
  fieldDescription: string;
  fieldActive: string;
  sectionAutomation: string;
  badgePublicCheckin: string;
  fieldCheckinUrl: string;
  btnCopy: string;
  checkinUrlHint: string;
  fieldCheckinWindowDays: string;
  checkinWindowHint: (days: number) => string;
  documentScanLabel: string;
  documentScanHint: string;
  automationInfoTitle: string;
  automationStep1Title: string;
  automationStep1Desc: string;
  automationStep2Title: string;
  automationStep2Desc: string;
  automationStep3Title: string;
  automationStep3Desc: string;
  automationStep4Title: string;
  automationStep4Desc: string;
  automationStep5Title: string;
  automationStep5Desc: string;
  automationTip: string;
  overbookingTitle: string;
  overbookingDesc: string;
  sectionOverbooking: string;
  badgeCollision: string;
  fieldCollisionStrategy: string;
  strategyStrict: string;
  strategyFirstWins: string;
  strategyAllow: string;
  strategyStrictDesc: string;
  strategyFirstWinsDesc: string;
  strategyAllowDesc: string;
  collisionStrategyHint: string;
  // Ubyport tab
  ubyportCredentialsHeader: string;
  ubyportCredentialsDesc: string;
  ubyportGuideLabel: string;
  fieldUbyportUsername: string;
  ubyportUsernameHint: string;
  ubyportUsernameWarning: string;
  ubyportUsernamePlaceholder: string;
  fieldUbyportPassword: string;
  ubyportPasswordPlaceholderSet: string;
  ubyportPasswordPlaceholderEmpty: string;
  ubyportPasswordHintSet: string;
  ubyportPasswordHintEmpty: string;
  ubyportTestButton: string;
  ubyportTestRunning: string;
  ubyportTestOk: string;
  ubyportTestInvalid: string;
  ubyportTestIncomplete: string;
  ubyportTestTimeout: string;
  ubyportTestUnreachable: string;
  ubyportTestProviderError: string;
  ubyportTestNotConfigured: string;
  ubyportTestBusy: string;
  ubyportTestRateLimited: string;
  ubyportTestFillIn: string;
  ubyportTestFieldUsername: string;
  ubyportTestFieldPassword: string;
  ubyportTestFieldIdub: string;
  ubyportTestFailed: string;
  fieldIdub: string;
  fieldShortName: string;
  shortNameHint: string;
  shortNamePlaceholder: string;
  fieldHostFullName: string;
  fieldHostContact: string;
  hostContactPlaceholder: string;
  hostContactHint: string;
  autoSendLabel: string;
  autoSendEnabled: string;
  autoSendDisabled: string;
  autoSendHintEnabled: string;
  autoSendHintDisabled: string;
  /** "Advanced settings" fold that holds the cap and the delay (#206); closed by default. */
  autoSendAllLabel: string;
  autoSendAllHint: string;
  /** Collapsed-fold summary for a cap, e.g. "At most 2 guests". */
  autoSendMaxLabel: string;
  autoSendMaxHint: string;
  autoSendMaxInvalid: (max: number) => string;
  autoSendDelayLabel: string;
  autoSendDelay0: string;
  autoSendDelay1: string;
  autoSendDelay2: string;
  autoSendDelay3: string;
  autoSendDelayHint: string;
  autoSendDelayWarning: string;
  autoSendInvalidSave: string;
  // Dorucenka
  dorucenkaHeader: string;
  dorucenkaDesc: string;
  dorucenkaLabelFrom: string;
  dorucenkaLabelTo: string;
  dorucenkaRequesting: string;
  dorucenkaRequest: string;
  dorucenkaPending: string;
  dorucenkaProcessing: string;
  dorucenkaLabelRange: string;
  dorucenkaLabelRequested: string;
  dorucenkaEmailNotice: string;
  dorucenkaReadyHeader: string;
  dorucenkaFiles: (count: number) => string;
  dorucenkaLabelReady: string;
  dorucenkaLabelExpires: string;
  dorucenkaDownloading: string;
  dorucenkaDownload: string;
  dorucenkaNewRequest: string;
  dorucenkaFailedHeader: string;
  dorucenkaTryAgain: string;
  dorucenkaExpired: (from: string, to: string) => string;
  dorucenkaExpiredHint: string;
  // City Tax tab
  cityTaxHeader: string;
  cityTaxDesc: string;
  fieldCityTaxBankAccount: string;
  fieldCityTaxVariableSymbol: string;
  fieldCityTaxContact: string;
  cityTaxContactNone: string;
  fieldCityTaxMailbox: string;
  cityTaxMailboxNone: string;
  cityTaxMailboxOther: string;
  fieldCityTaxMailboxOtherName: string;
  fieldCityTaxMailboxOtherDataboxId: string;
  fieldCityTaxMailboxOtherAddress: string;
  cityTaxMailboxDataboxHint: string;
  fieldAdultRate: string;
  fieldChildRate: string;
  fieldDisabledRate: string;
  viewCityTaxReport: string;
  cityTaxCollectionLabel: string;
  cityTaxCollectionEnabledText: string;
  cityTaxCollectionDisabledText: string;
  cityTaxCollectionHint: string;
  cityTaxStripeConnectLink: string;
  cityTaxPaymentMethodNone: string;
  cityTaxPaymentMethodEmpty: string;
  cityTaxPaymentMethodNotReady: string;
  cityTaxPaymentMethodRequiredError: string;
  cityTaxApplicationFeeNote: string;
  // Contact tab
  contactHeader: string;
  contactDesc: string;
  contactSourceManager: string;
  contactSourceList: string;
  contactSourceOther: string;
  selectContact: string;
  editContactDetails: string;
  contactReadOnlyHint: string;
  fieldContactFullName: string;
  fieldContactEmail: string;
  fieldContactPhone: string;
  fieldContactCompanyName: string;
  fieldContactIco: string;
  fieldContactAddress: string;
  footerHeader: string;
  footerDesc: string;
  fieldFooterType: string;
  footerTypeManager: string;
  footerTypeContact: string;
  footerContactFullName: string;
  footerContactEmail: string;
  footerContactPhone: string;
  // Guide tab
  guideIntroTitle: string;
  guideIntroDesc: string;
  guideIntroStep1Label: string;
  guideIntroStep1Desc: string;
  guideIntroStep2Label: string;
  guideIntroStep2Desc: string;
  guideIntroStep3Label: string;
  guideIntroStep3Desc: string;
  guideSectionSettings: string;
  guideEnable: string;
  guideVisibleSections: string;
  guideSecAddress: string;
  guideSecKeyAccess: string;
  guideSecWifi: string;
  guideSecParking: string;
  guideSecHostContact: string;
  guideSecDetailedGuide: string;
  guideSecPhotos: string;
  guideSecOtherLinks: string;
  guideSecAttentionNotes: string;
  guideSecCheckoutInstructions: string;
  guideSecWeather: string;
  guideSectionLocation: string;
  guideFieldCheckinTime: string;
  guideFieldCheckoutTime: string;
  guideFieldAddress: string;
  guideFieldAddressRemark: string;
  guideAddressRemarkPlaceholder: string;
  guideSectionKeyAccess: string;
  guideFieldAccessType: string;
  guideAccessTypeSelect: string;
  guideAccessTypeDoorCode: string;
  guideAccessTypeKeybox: string;
  guideAccessTypePerson: string;
  guideAccessTypeNoKey: string;
  guideAccessTypeTtlock: string;
  guideFieldSmartLock: string;
  guideSelectLock: string;
  guideFieldOfflineFallback: string;
  guideOfflineFallbackHint: string;
  guideFieldKeyCode: string;
  guideKeyCodePlaceholder: string;
  guidePinVisibleFrom: string;
  guideCodeVisibleFrom: string;
  guideVisibilityAlways: string;
  guideVisibilityFrom: string;
  guidePinHiddenUntil: (time: string) => string;
  guideCodeHiddenUntil: (time: string) => string;
  guideFieldKeyRemark: string;
  guideKeyRemarkPlaceholder: string;
  guideSectionAmenities: string;
  guideFieldWifiName: string;
  guideFieldWifiPassword: string;
  guideFieldParkingInfo: string;
  guideParkingPlaceholder: string;
  guideFieldParkingPrice: string;
  guideParkingPricePlaceholder: string;
  guideSectionHostContact: string;
  guideHostName: string;
  guideHostPhone: string;
  guideHostEmail: string;
  guideSectionGuestInstructions: string;
  guideDetailedGuidePlaceholder: string;
  guideAttentionPlaceholder: string;
  guideCheckoutPlaceholder: string;
  guideEnglishVersionAdd: string;
  guideEnglishVersionLabel: string;
  guideEnglishVersionClear: string;
  guideSectionOtherLinks: string;
  guideLinkLabelPlaceholder: string;
  guideLinkUrlPlaceholder: string;
  guideAddLink: string;
  guideSaving: string;
  guideSave: string;
  guideSavedSuccess: string;
  guideSectionPhotos: string;
  guidePhotosDesc: string;
  guidePhotoCaption: string;
  guidePhotoCaptionPlaceholder: string;
  guidePhotoUploading: (pct: number) => string;
  guidePhotoAdd: string;
  guidePhotoFileHint: (used: number) => string;
  guidePhotoMaxReached: string;
  guidePhotoConfirmDelete: string;
  // Export tab
  exportHeader: string;
  exportDesc: string;
  exportLabelFrom: string;
  exportLabelTo: string;
  exportCsvLoading: string;
  exportCsv: string;
  exportPdfLoading: string;
  exportPdf: string;
  exportCsvDesc: string;
  exportCsvBadge: string;
  exportPdfDesc: string;
  exportPdfBadge: string;
  // Delete modal
  deleteModalHeader: string;
  deleteModalDescPre: string;
  deleteModalDescPost: string;
  deleteModalWillDelete: string;
  deleteModalReservations: (count: number) => string;
  deleteModalUbyportSubmitted: (count: number) => string;
  deleteModalDorucenka: (count: number) => string;
  deleteModalCalendars: (count: number) => string;
  deleteModalTypeToConfirm: string;
  cancel: string;
  deleting: string;
  deleteConfirm: string;
}

export const apartmentDetailText: Record<Lang, ApartmentDetailText> = {
  cs: {
    loading: 'Načítám detail apartmánu…',
    loadingGuide: 'Načítám průvodce…',
    notFound: 'Apartmán nenalezen.',
    back: '← Zpět na apartmány',
    subtitle: 'Konfigurace apartmánu',
    savedSuccess: 'Nastavení apartmánu bylo uloženo.',
    copySuccess: 'URL check-in zkopírována.',
    copyError: 'Nepodařilo se zkopírovat URL check-in',
    saving: 'Ukládám…',
    saveChanges: 'Uložit změny',
    deleteApartment: 'Smazat apartmán',
    deleteApartmentDescription: 'Smazáním odstraníte tento apartmán, jeho rezervace, formuláře hostů, připojené kalendáře a uložené doručenky. Smazání nelze vrátit v aplikaci. Před pokračováním exportujte potřebná data a stáhněte doručenky. Další krok zobrazí přehled a vyžádá potvrzení názvem apartmánu.',
    tabGeneral: '⚙️ Obecné',
    tabContact: '👤 Kontakt',
    tabUbyport: '🏛️ Ubyport',
    tabCityTax: '💰 Místní poplatek',
    tabPayments: '💳 Platby',
    paymentsHeader: 'Platby za tento apartmán',
    paymentsDesc: 'Pro každý druh plateb si můžete zvolit jiný propojený Stripe účet, nebo všude stejný.',
    paymentsPurposeCityTax: 'Místní poplatek',
    paymentsPurposeCityTaxHint: 'Sem se vybírá místní poplatek od hostů.',
    paymentsPurposeUpsell: 'Doplňkové služby (dřívější příjezd, pozdější odjezd, úschova zavazadel)',
    paymentsPurposeUpsellHint: 'Sem se platí za doplňkové služby, které host k pobytu přikoupí.',
    paymentsPurposeDeposit: 'Kauce',
    paymentsPurposeDepositHint: 'Na tomto účtu se uloží karta hosta a rezervuje kauce.',
    paymentsPurposeNotReady: 'Vybraný Stripe účet ještě není plně nastaven — platby tohoto druhu nebudou fungovat, dokud propojení nedokončíte.',
    paymentsNoneCityTax: 'Není vybrán žádný účet — hosté zde nemohou zaplatit místní poplatek.',
    paymentsNoneUpsell: 'Není vybrán žádný účet — hosté zde nemohou zaplatit za doplňkové služby.',
    paymentsNoneDeposit: 'Není vybrán žádný účet — kauci zde nelze vybrat.',
    paymentMethodInvalidError: 'Vybraný Stripe účet pro „{purpose}“ není váš propojený účet. Načtěte stránku znovu a vyberte ho znovu.',
    cityTaxPaysToAccount: 'Poplatek se vybírá na účet {account}.',
    cityTaxNeedsAccount: 'Nejprve vyberte Stripe účet pro tento apartmán.',
    cityTaxOpenPayments: 'Otevřít Platby',
    tabCalendar: '📅 Sync kalendáře',
    tabGuide: '🏠 Průvodce',
    tabUpsell: '🎁 Doplňkové služby',
    tabDeposit: '🔒 Kauce',
    tabBooking: '🌐 Přímá rezervace',
    tabExport: '⬇ Export',
    fieldInternalName: 'Interní název',
    fieldDisplayName: 'Zobrazovaný název',
    fieldAddress: 'Adresa',
    fieldCapacity: 'Kapacita',
    fieldDescription: 'Popis',
    fieldActive: 'Aktivní',
    sectionAutomation: 'Automatizace',
    badgePublicCheckin: 'Veřejný check-in',
    fieldCheckinUrl: 'Veřejná URL pro check-in hostů',
    btnCopy: 'Kopírovat',
    checkinUrlHint: 'Sdílejte tuto stálou URL v automatické zprávě na Airbnb/Booking.',
    fieldCheckinWindowDays: 'Okno pro check-in (počet dní dopředu)',
    checkinWindowHint: (days) => `Hosté mohou zahájit check-in pro příjezdy od dnes až ${days} dní dopředu.`,
    documentScanLabel: 'Umožnit hostům skenovat doklad',
    documentScanHint: 'Hosté si mohou telefonem naskenovat pas/OP a nechat si předvyplnit formulář. Před podpisem vše stále zkontrolují a potvrdí.',
    automationInfoTitle: 'Jak automatizovat registraci hostů',
    automationStep1Title: '1. Zkopírujte odkaz',
    automationStep1Desc: 'Zkopírujte Veřejnou URL pro check-in hostů z políčka výše',
    automationStep2Title: '2. Vložte do zprávy',
    automationStep2Desc: 'Přidejte odkaz do vaší automatické zprávy na Airbnb / Booking.com',
    automationStep3Title: '3. Host zarezervuje',
    automationStep3Desc: 'Host obdrží vaši automatickou zprávu s odkazem na registraci',
    automationStep4Title: '4. Host se zaregistruje',
    automationStep4Desc: 'Host vyplní check-in formulář se svými osobními údaji a dokumenty',
    automationStep5Title: '5. Hotovo!',
    automationStep5Desc: 'Data hosta jsou automaticky uložena — připravena k odeslání do Ubyportu',
    automationTip: 'Tip: Na Airbnb přejděte do Doručená pošta → Naplánované zprávy. Na Booking.com přejděte do Zprávy → Automatické zprávy. Vložte odkaz jako prostý text nebo hypertextový odkaz.',
    overbookingTitle: 'Přebukování',
    overbookingDesc: 'Pokud mají dva kalendáře překrývající se rezervace, vyhraje ta z kalendáře s vyšší prioritou a druhá bude označena jako Přebukovaná. Pořadí kalendářů změníte níže pomocí tlačítek ▲ / ▼ — vrchní kalendář vždy vyhrává. Manuální rezervace mají vždy přednost před importovanými.',
    sectionOverbooking: 'Strategie přebukování',
    badgeCollision: 'Řešení kolizí',
    fieldCollisionStrategy: 'Při detekci překrývajících se rezervací',
    strategyStrict: 'Přísné',
    strategyFirstWins: 'První vyhrává',
    strategyAllow: 'Povolit',
    strategyStrictDesc: 'Všechny překrývající se rezervace jsou neaktivní.',
    strategyFirstWinsDesc: 'Nejstarší rezervace zůstane aktivní, ostatní budou neaktivní.',
    strategyAllowDesc: 'Vše zůstane aktivní, správce bude jen upozorněn.',
    collisionStrategyHint: 'Aplikuje se automaticky při detekci překryvů v kalendáři. Ruční rozhodnutí nejsou přepisována.',
    ubyportCredentialsHeader: 'Přihlašovací údaje Ubyport pro apartmán',
    ubyportCredentialsDesc: 'Česká legislativa ukládá ubytovatelům povinnost evidovat a odesílat osobní údaje hostů do systému Ubyport. Přihlašovací údaje (uživatelské jméno, heslo, IDUB) naleznete přímo ve svém účtu Ubyport.',
    ubyportGuideLabel: 'Jak nastavit Ubyport? → Průvodce',
    fieldUbyportUsername: 'Ubyport uživatelské jméno',
    ubyportUsernameHint: 'Uživatelské jméno pro webovou službu Ubyport (Webservice). Musí začínat prefixem UBY-WS_.',
    ubyportUsernameWarning: 'Toto přihlašovací jméno pravděpodobně nebude fungovat pro automatické odesílání — přihlašovací údaje webové služby musí začínat prefixem UBY-WS_. Podrobnosti najdete v průvodci výše.',
    ubyportUsernamePlaceholder: 'UBY-WS_XXXXX',
    fieldUbyportPassword: 'Ubyport heslo',
    ubyportPasswordPlaceholderSet: 'Uložené heslo zůstane, pokud nezadáte nové',
    ubyportPasswordPlaceholderEmpty: 'Zadejte heslo apartmánu',
    ubyportPasswordHintSet: 'Heslo je již uloženo. Ponechte prázdné pro zachování stávajícího.',
    ubyportPasswordHintEmpty: 'Zatím není uloženo žádné heslo.',
    ubyportTestButton: 'Otestovat přihlašovací údaje',
    ubyportTestRunning: 'Testuji…',
    ubyportTestOk: 'V pořádku',
    ubyportTestInvalid: 'Ubyport odmítl jméno nebo heslo. Opakované chybné pokusy mohou účet zablokovat.',
    ubyportTestIncomplete: 'Vyplňte jméno i heslo',
    ubyportTestTimeout: 'Ubyport neodpověděl, zkuste to znovu',
    ubyportTestUnreachable: 'K Ubyportu se nepodařilo připojit, zkuste to znovu',
    ubyportTestProviderError: 'Ubyport vrátil chybu, zkuste to později',
    ubyportTestNotConfigured: 'Ubyport zatím není na platformě nastaven. Kontaktujte podporu',
    ubyportTestBusy: 'Test právě probíhá',
    ubyportTestRateLimited: 'Příliš mnoho testů, chvíli počkejte',
    ubyportTestFillIn: 'Vyplňte',
    ubyportTestFieldUsername: 'uživatelské jméno',
    ubyportTestFieldPassword: 'heslo',
    ubyportTestFieldIdub: 'IDUB',
    ubyportTestFailed: 'Test se nepodařilo provést, zkuste to znovu',
    fieldIdub: 'IDUB',
    fieldShortName: 'Identifikátor Ubyport',
    shortNameHint: 'Pravá část uživatelského jména za podtržítkem. Pokud je uživatelské jméno UBY-WS_XXXXX, zadejte XXXXX. Max 10 znaků.',
    shortNamePlaceholder: 'XXXXX (z UBY‑WS_XXXXX)',
    fieldHostFullName: 'Celé jméno hostitele',
    fieldHostContact: 'Kontakt hostitele',
    hostContactPlaceholder: 'Telefonní číslo nebo e-mail',
    hostContactHint: 'Telefon nebo e-mail odesílaný do Ubyportu jako kontakt hostitele.',
    autoSendLabel: 'Automatické odeslání do Ubyportu',
    autoSendEnabled: '✓ Zapnuto',
    autoSendDisabled: '— Vypnuto',
    autoSendHintEnabled: 'Data hostů budou odeslána do Ubyportu automaticky do ~5 min po dokončení formuláře.',
    autoSendHintDisabled: 'Zapněte až po ověření přihlašovacích údajů a IDUB apartmánu.',
    autoSendAllLabel: 'Odesílat všechny hosty',
    autoSendAllHint: 'Doporučeno. Automaticky se nahlásí všichni cizinci z rezervace.',
    autoSendMaxLabel: 'Max. hostů odesílaných automaticky na rezervaci',
    autoSendMaxHint: 'Zbývající hosté čekají, až je zkontrolujete a odešlete ručně. Čeští hosté se nepočítají (do Ubyportu se neohlašují).',
    autoSendMaxInvalid: (max) => `Zadejte celé číslo od 1 do ${max} (kapacita apartmánu).`,
    autoSendDelayLabel: 'Odesílat automaticky',
    autoSendDelay0: 'v den příjezdu',
    autoSendDelay1: '1 den po příjezdu',
    autoSendDelay2: '2 dny po příjezdu',
    autoSendDelay3: '3 dny po příjezdu',
    autoSendDelayHint: 'Zákon vyžaduje nahlásit cizince do 3 pracovních dnů od příjezdu. Pozdější den znamená méně času na opravu odmítnuté registrace.',
    autoSendDelayWarning: 'Ve 3. dni už nezbývá žádný čas opravit údaje, které Ubyport odmítne – hrozí zmeškání zákonné lhůty.',
    autoSendInvalidSave: 'Nastavení automatického odesílání do Ubyportu není platné. Opravte ho a uložte znovu.',
    dorucenkaHeader: 'Doručenky',
    dorucenkaDesc: 'Stáhněte všechny PDF doručenky z Ubyportu pro dané období jako ZIP archiv. Najednou může být aktivní pouze jedna úloha stahování. ZIP je dostupný 48 hodin.',
    dorucenkaLabelFrom: 'Od',
    dorucenkaLabelTo: 'Do',
    dorucenkaRequesting: 'Požaduji…',
    dorucenkaRequest: 'Požádat o stažení',
    dorucenkaPending: 'Připravuji stahování…',
    dorucenkaProcessing: 'Vytvářím ZIP archiv…',
    dorucenkaLabelRange: 'Období:',
    dorucenkaLabelRequested: 'Požadováno:',
    dorucenkaEmailNotice: 'Emailem vás upozorníme, až budou soubory připraveny. Můžete také zůstat na této stránce — automaticky se aktualizuje.',
    dorucenkaReadyHeader: 'Stahování připraveno',
    dorucenkaFiles: (count) => `${count} soubor${count === 1 ? '' : count >= 2 && count <= 4 ? 'y' : 'ů'}`,
    dorucenkaLabelReady: 'Připraveno:',
    dorucenkaLabelExpires: 'Vyprší:',
    dorucenkaDownloading: 'Otevírám…',
    dorucenkaDownload: 'Stáhnout ZIP',
    dorucenkaNewRequest: 'Nový požadavek',
    dorucenkaFailedHeader: 'Stahování selhalo',
    dorucenkaTryAgain: 'Zkusit znovu',
    dorucenkaExpired: (from, to) => `Předchozí stahování vypršelo (${from} – ${to}).`,
    dorucenkaExpiredHint: 'Požádejte o nové výše.',
    cityTaxHeader: 'Sazby místního poplatku',
    cityTaxDesc: 'Nastavte noční poplatek na hosta pro každou kategorii. Ponechte prázdné, pokud je kategorie osvobozena. Hosté mladší 18 let při příjezdu jsou klasifikováni jako děti. Hosté s průkazem ZTP/P jsou klasifikováni jako zdravotně postižení.',
    fieldCityTaxBankAccount: 'Číslo účtu pro odvod poplatku',
    fieldCityTaxVariableSymbol: 'Variabilní symbol',
    fieldCityTaxContact: 'Plátce (kontakt)',
    cityTaxContactNone: '— Nepřiřazeno —',
    fieldCityTaxMailbox: 'Datová schránka příjemce',
    cityTaxMailboxNone: '— Vyberte datovou schránku —',
    cityTaxMailboxOther: 'Jiná',
    fieldCityTaxMailboxOtherName: 'Název úřadu',
    fieldCityTaxMailboxOtherDataboxId: 'ID datové schránky',
    fieldCityTaxMailboxOtherAddress: 'Adresa úřadu',
    cityTaxMailboxDataboxHint: 'Vyhledat ID datové schránky',
    fieldAdultRate: 'Sazba pro dospělé (na hosta/noc)',
    fieldChildRate: 'Sazba pro děti (do 18 let, na hosta/noc)',
    fieldDisabledRate: 'Sazba pro ZTP/P (na hosta/noc)',
    viewCityTaxReport: 'Zobrazit přehled místního poplatku →',
    cityTaxCollectionLabel: 'Výběr poplatku online:',
    cityTaxCollectionEnabledText: 'Zapnuto',
    cityTaxCollectionDisabledText: 'Vypnuto',
    cityTaxCollectionHint: 'Pokud zapnete, host musí poplatek zaplatit kartou dříve, než se mu zobrazí průvodce ubytováním.',
    cityTaxStripeConnectLink: 'Propojit ve Nastavení →',
    cityTaxPaymentMethodNone: '— Vyberte účet —',
    cityTaxPaymentMethodEmpty: 'Nemáte žádný Stripe účet. Přidejte ho v Nastavení → Platební metody.',
    cityTaxPaymentMethodNotReady: 'Vybraný Stripe účet ještě není plně nastaven — výběr poplatku nebude fungovat, dokud propojení nedokončíte.',
    cityTaxPaymentMethodRequiredError: 'Pro zapnutý online výběr poplatku vyberte plně propojený Stripe účet.',
    cityTaxApplicationFeeNote: 'Servisní poplatek {rate} z každé platby.',
    contactHeader: 'Přiřazený kontakt',
    contactDesc: 'Kdo spravuje tento apartmán. Používá se pro oznámení uklízeče a zápatí formuláře hosta.',
    contactSourceManager: 'Kontakt správce',
    contactSourceList: 'Ze seznamu kontaktů',
    contactSourceOther: 'Jiný',
    selectContact: '— Vyberte kontakt —',
    editContactDetails: 'Kontakt',
    contactReadOnlyHint: 'Upravit v Profilu → Kontakty →',
    fieldContactFullName: 'Celé jméno',
    fieldContactEmail: 'E-mail',
    fieldContactPhone: 'Telefon',
    fieldContactCompanyName: 'Název společnosti / fyzická osoba',
    fieldContactIco: 'IČ',
    fieldContactAddress: 'Adresa',
    footerHeader: 'Zápatí formuláře hosta',
    footerDesc: 'Zvolte, který kontakt se zobrazí v zápatí formuláře check-in hosta.',
    fieldFooterType: 'Zobrazit v zápatí formuláře hosta',
    footerTypeManager: 'Dle nastavení výše',
    footerTypeContact: 'Jiný kontakt',
    footerContactFullName: 'Jiný kontakt – celé jméno',
    footerContactEmail: 'Jiný kontakt – e-mail',
    footerContactPhone: 'Jiný kontakt – telefon',
    guideIntroTitle: 'Co je průvodce check-in?',
    guideIntroDesc: 'Personalizovaná webová stránka automaticky zaslaná vašim hostům — obsahuje vše potřebné pro hladký příjezd.',
    guideIntroStep1Label: 'Vyplňte informace',
    guideIntroStep1Desc: 'Přidejte adresu, WiFi, přístup ke klíči, parkování, fotografie a další pokyny.',
    guideIntroStep2Label: 'Host obdrží odkaz',
    guideIntroStep2Desc: 'Po odeslání registračního formuláře host automaticky obdrží odkaz na průvodce e-mailem.',
    guideIntroStep3Label: 'Host vidí průvodce',
    guideIntroStep3Desc: 'Osobní digitální průvodce s informacemi o apartmánu — dostupný kdykoli v telefonu.',
    guideSectionSettings: 'Nastavení průvodce',
    guideEnable: 'Aktivovat průvodce check-in pro tento apartmán',
    guideVisibleSections: 'Viditelné sekce',
    guideSecAddress: '📍 Adresa',
    guideSecKeyAccess: '🔑 Přístup klíčem',
    guideSecWifi: '📶 WiFi',
    guideSecParking: '🚗 Parkování',
    guideSecHostContact: '📞 Kontakt hostitele',
    guideSecDetailedGuide: '📖 Podrobný průvodce',
    guideSecPhotos: '🖼️ Fotky',
    guideSecOtherLinks: '🔗 Další odkazy',
    guideSecAttentionNotes: '⚠️ Pozor na',
    guideSecCheckoutInstructions: '🚪 Pokyny pro odjezd',
    guideSecWeather: '🌤️ Počasí',
    guideSectionLocation: 'Check-in a poloha',
    guideFieldCheckinTime: 'Čas příjezdu',
    guideFieldCheckoutTime: 'Čas odjezdu',
    guideFieldAddress: 'Adresa',
    guideFieldAddressRemark: 'Poznámka k adrese',
    guideAddressRemarkPlaceholder: 'např. 3. patro, zvonek č. 12, kód brány 1234',
    guideSectionKeyAccess: 'Přístup klíčem',
    guideFieldAccessType: 'Typ přístupu',
    guideAccessTypeSelect: '— Vyberte —',
    guideAccessTypeDoorCode: 'Dveřní kód',
    guideAccessTypeKeybox: 'Schránka na klíče',
    guideAccessTypePerson: 'Osobně / od hostitele',
    guideAccessTypeNoKey: 'Klíč není potřeba',
    guideAccessTypeTtlock: '🔐 Chytrý zámek (TTLock)',
    guideFieldSmartLock: 'Chytrý zámek',
    guideSelectLock: '— Vyberte zámek —',
    guideFieldOfflineFallback: 'Automaticky použít offline kód při selhání',
    guideOfflineFallbackHint: 'Pokud se PIN nepodaří vygenerovat (např. zámek není připojen k bráně), systém automaticky získá cloudový offline kód, který funguje i bez připojení zámku.',
    guideFieldKeyCode: 'Kód klíče',
    guideKeyCodePlaceholder: 'Kód dveří / schránky',
    guidePinVisibleFrom: 'PIN viditelný od',
    guideCodeVisibleFrom: 'Kód viditelný od',
    guideVisibilityAlways: 'Vždy viditelný',
    guideVisibilityFrom: 'Viditelný od:',
    guidePinHiddenUntil: (time) => `PIN bude skrytý do ${time} v den příjezdu.`,
    guideCodeHiddenUntil: (time) => `Kód bude skrytý do ${time} v den příjezdu.`,
    guideFieldKeyRemark: 'Poznámka ke klíči',
    guideKeyRemarkPlaceholder: 'Další pokyny ke klíči / vstupu',
    guideSectionAmenities: 'Vybavení',
    guideFieldWifiName: 'Název WiFi sítě',
    guideFieldWifiPassword: 'Heslo WiFi',
    guideFieldParkingInfo: 'Informace o parkování',
    guideParkingPlaceholder: 'Místo parkování, pokyny',
    guideFieldParkingPrice: 'Cena parkování',
    guideParkingPricePlaceholder: 'např. Zdarma, 100 Kč/den',
    guideSectionHostContact: 'Kontakt hostitele',
    guideHostName: 'Jméno',
    guideHostPhone: 'Telefon',
    guideHostEmail: 'E-mail',
    guideSectionGuestInstructions: 'Pokyny pro hosty',
    guideDetailedGuidePlaceholder: 'Pravidla domu, návody k spotřebičům, třídění odpadu, nouzové kontakty…',
    guideAttentionPlaceholder: 'Důležitá upozornění, která hosté nesmí přehlédnout (např. nebouchejte dveřmi, zákaz kouření, noční klid…)',
    guideCheckoutPlaceholder: 'Kroky pro odjezd (např. zanechte klíče ve schránce, vyneste koš, zavřete okna…)',
    guideEnglishVersionAdd: '+ Přidat anglickou verzi',
    guideEnglishVersionLabel: 'Anglická verze (volitelné)',
    guideEnglishVersionClear: 'Smazat',
    guideSectionOtherLinks: 'Další odkazy',
    guideLinkLabelPlaceholder: 'Název (např. YouTube)',
    guideLinkUrlPlaceholder: 'URL',
    guideAddLink: '+ Přidat odkaz',
    guideSaving: 'Ukládám…',
    guideSave: 'Uložit průvodce',
    guideSavedSuccess: 'Průvodce check-in byl uložen.',
    guideSectionPhotos: 'Fotky',
    guidePhotosDesc: 'Nahrajte fotky, které hosté uvidí v průvodci check-in (např. vchod, schránka na klíče, parkování). Max 10 fotek, každá do 10 MB. Fotky jsou uloženy okamžitě.',
    guidePhotoCaption: 'Popisek (volitelný)',
    guidePhotoCaptionPlaceholder: 'např. Schránka na klíče na pravé straně dveří',
    guidePhotoUploading: (pct) => `Nahrávám… ${pct}%`,
    guidePhotoAdd: '+ Přidat fotku',
    guidePhotoFileHint: (used) => `JPEG, PNG, WebP, HEIC · max 10 MB · ${used}/10 použito`,
    guidePhotoMaxReached: 'Dosáhli jste maxima 10 fotek. Smažte fotku, abyste mohli nahrát novou.',
    guidePhotoConfirmDelete: 'Smazat tuto fotku?',
    exportHeader: 'Export rezervací',
    exportDesc: 'Exportujte všechny rezervace a data registrovaných hostů pro dané období (dle data příjezdu). CSV obsahuje všechna pole bez podpisů. PDF obsahuje kompaktní tabulku s podpisy.',
    exportLabelFrom: 'Od',
    exportLabelTo: 'Do',
    exportCsvLoading: 'Připravuji CSV…',
    exportCsv: '⬇ Export CSV',
    exportPdfLoading: 'Generuji PDF…',
    exportPdf: '⬇ Export PDF',
    exportCsvDesc: 'Jeden řádek na hosta, všechna pole, bez podpisu. Vhodné pro tabulky.',
    exportCsvBadge: 'Tabulka',
    exportPdfDesc: 'Kompaktní tabulka na šířku s malými vloženými podpisy, optimalizovaná pro minimum stránek.',
    exportPdfBadge: 'S podpisy',
    deleteModalHeader: 'Smazat apartmán',
    deleteModalDescPre: 'Tato akce trvale smaže',
    deleteModalDescPost: 'a všechna přidružená data.',
    deleteModalWillDelete: 'Následující bude trvale smazáno:',
    deleteModalReservations: (count) => `${count} rezervac${count === 1 ? 'e' : count >= 2 && count <= 4 ? 'e' : 'í'}`,
    deleteModalUbyportSubmitted: (count) => `(${count} odesláno do Ubyportu)`,
    deleteModalDorucenka: (count) => `${count} doručenk${count === 1 ? 'a' : count >= 2 && count <= 4 ? 'y' : ''} PDF — váš doklad o souladu s Ubyportem. Exportujte je před pokračováním.`,
    deleteModalCalendars: (count) => `${count} připojený${count === 1 ? '' : 'ch'} kalendář${count === 1 ? '' : 'ů'}`,
    deleteModalTypeToConfirm: 'Zadejte název apartmánu pro potvrzení:',
    cancel: 'Zrušit',
    deleting: 'Mažu…',
    deleteConfirm: 'Trvale smazat',
  },
  en: {
    loading: 'Loading apartment detail...',
    loadingGuide: 'Loading guide…',
    notFound: 'Apartment not found.',
    back: '← Back to Apartments',
    subtitle: 'Apartment detail configuration',
    savedSuccess: 'Apartment settings saved successfully.',
    copySuccess: 'Check-in URL copied.',
    copyError: 'Failed to copy check-in URL',
    saving: 'Saving…',
    saveChanges: 'Save Changes',
    deleteApartment: 'Delete Apartment',
    deleteApartmentDescription: 'Deleting removes this apartment, its reservations, guest forms, connected calendars and stored delivery receipts. Deletion cannot be undone in the app. Export the data you need and download receipts before continuing. The next step shows a summary and asks you to confirm with the apartment name.',
    tabGeneral: '⚙️ General',
    tabContact: '👤 Contact',
    tabUbyport: '🏛️ Ubyport',
    tabCityTax: '💰 City Tax',
    tabPayments: '💳 Payments',
    paymentsHeader: 'Payments for this apartment',
    paymentsDesc: 'Pick a connected Stripe account for each kind of payment — or the same one for all of them.',
    paymentsPurposeCityTax: 'City tax',
    paymentsPurposeCityTaxHint: 'Where the city tax collected from guests is paid.',
    paymentsPurposeUpsell: 'Extras (early check-in, late check-out, luggage storage)',
    paymentsPurposeUpsellHint: 'Where guests pay for the extras they add to their stay.',
    paymentsPurposeDeposit: 'Deposit',
    paymentsPurposeDepositHint: 'The guest\'s card is saved and the deposit reserved on this account.',
    paymentsPurposeNotReady: 'The selected Stripe account isn\'t fully set up yet — payments of this kind will not work until you finish connecting it.',
    paymentsNoneCityTax: 'No account selected — guests cannot pay city tax here.',
    paymentsNoneUpsell: 'No account selected — guests cannot pay for extras here.',
    paymentsNoneDeposit: 'No account selected — deposits cannot be taken here.',
    paymentMethodInvalidError: 'The Stripe account chosen for "{purpose}" is not one of your connected accounts. Reload the page and pick it again.',
    cityTaxPaysToAccount: 'Tax is collected into {account}.',
    cityTaxNeedsAccount: 'Choose a Stripe account for this apartment first.',
    cityTaxOpenPayments: 'Open Payments',
    tabCalendar: '📅 Calendar Sync',
    tabGuide: '🏠 Guide',
    tabUpsell: '🎁 Upsell',
    tabDeposit: '🔒 Deposit',
    tabBooking: '🌐 Direct Booking',
    tabExport: '⬇ Export',
    fieldInternalName: 'Internal Name',
    fieldDisplayName: 'Apartment Display Name',
    fieldAddress: 'Address',
    fieldCapacity: 'Capacity',
    fieldDescription: 'Description',
    fieldActive: 'Active',
    sectionAutomation: 'Automation',
    badgePublicCheckin: 'Public check-in',
    fieldCheckinUrl: 'Public Guest Check-in URL',
    btnCopy: 'Copy',
    checkinUrlHint: 'Share this static URL in your Airbnb/Booking automatic message.',
    fieldCheckinWindowDays: 'Check-in range (days ahead)',
    checkinWindowHint: (days) => `Guests can start check-in for arrivals between today and ${days} day(s) ahead.`,
    documentScanLabel: 'Let guests scan their document',
    documentScanHint: 'Guests can scan their passport/ID with their phone camera to prefill the form. They still review and confirm everything before signing.',
    automationInfoTitle: 'How to automate guest registration',
    automationStep1Title: '1. Copy the link',
    automationStep1Desc: 'Copy the Public Guest Check-in URL from the field above',
    automationStep2Title: '2. Paste in message',
    automationStep2Desc: 'Add the link to your automated booking message in Airbnb / Booking.com',
    automationStep3Title: '3. Guest books',
    automationStep3Desc: 'Guest receives your automated message with the registration link',
    automationStep4Title: '4. Guest registers',
    automationStep4Desc: 'Guest fills the check-in form with their personal & document info',
    automationStep5Title: '5. Done!',
    automationStep5Desc: 'Guest data is automatically saved — ready for Ubyport reporting',
    automationTip: 'Tip: In Airbnb go to Inbox → Scheduled messages. In Booking.com go to Messaging → Auto-messages. Paste the link as plain text or as a hyperlink.',
    overbookingTitle: 'Overbooking',
    overbookingDesc: 'When two calendars have overlapping reservations, the one from the higher-priority calendar wins and the other is marked Overbooked. Reorder your calendars below using the ▲ / ▼ buttons — the top calendar always wins. Manual reservations always take priority over imported ones.',
    sectionOverbooking: 'Overbooking strategy',
    badgeCollision: 'Collision resolution',
    fieldCollisionStrategy: 'When overlapping reservations are detected',
    strategyStrict: 'Strict',
    strategyFirstWins: 'First wins',
    strategyAllow: 'Allow',
    strategyStrictDesc: 'All overlapping reservations become inactive.',
    strategyFirstWinsDesc: 'Oldest reservation stays active, others become inactive.',
    strategyAllowDesc: 'All stay active, manager is notified only.',
    collisionStrategyHint: 'Applied automatically when the calendar sync detects overlaps. Manual decisions are never overwritten.',
    ubyportCredentialsHeader: 'Apartment-owned Ubyport credentials',
    ubyportCredentialsDesc: 'Czech law requires hosts to record and submit guest personal data to Ubyport. You can obtain your credentials (username, password, IDUB) directly in your Ubyport account.',
    ubyportGuideLabel: 'How to set up Ubyport? → Guide',
    fieldUbyportUsername: 'Ubyport Username',
    ubyportUsernameHint: 'Webservice username for Ubyport. Must start with the prefix UBY-WS_.',
    ubyportUsernameWarning: 'This login may not work for automatic submission — web service credentials must start with UBY-WS_. See the guide above for details.',
    ubyportUsernamePlaceholder: 'UBY-WS_XXXXX',
    fieldUbyportPassword: 'Ubyport Password',
    ubyportPasswordPlaceholderSet: 'Stored secret is kept unless you enter a new one',
    ubyportPasswordPlaceholderEmpty: 'Enter apartment secret',
    ubyportPasswordHintSet: 'A secret is already stored. Leave this blank to keep it unchanged.',
    ubyportPasswordHintEmpty: 'No apartment secret stored yet.',
    ubyportTestButton: 'Test credentials',
    ubyportTestRunning: 'Testing…',
    ubyportTestOk: 'Credentials accepted',
    ubyportTestInvalid: 'Ubyport rejected the username or password. Repeated wrong attempts can lock the account.',
    ubyportTestIncomplete: 'Enter username and password',
    ubyportTestTimeout: 'Ubyport did not answer, try again',
    ubyportTestUnreachable: 'Could not connect to Ubyport, try again',
    ubyportTestProviderError: 'Ubyport returned an error, try later',
    ubyportTestNotConfigured: 'Ubyport is not set up on the platform yet. Contact support',
    ubyportTestBusy: 'A test is already running',
    ubyportTestRateLimited: 'Too many tests, wait a moment',
    ubyportTestFillIn: 'Fill in',
    ubyportTestFieldUsername: 'username',
    ubyportTestFieldPassword: 'password',
    ubyportTestFieldIdub: 'IDUB',
    ubyportTestFailed: 'The test could not be run, try again',
    fieldIdub: 'IDUB',
    fieldShortName: 'Ubyport Identifier',
    shortNameHint: 'The right part of your Ubyport username after the underscore. If your username is UBY-WS_XXXXX, enter XXXXX. Max 10 characters.',
    shortNamePlaceholder: 'XXXXX (from UBY‑WS_XXXXX)',
    fieldHostFullName: 'Host Full Name',
    fieldHostContact: 'Host Contact',
    hostContactPlaceholder: 'Phone number or email',
    hostContactHint: 'Telephone or email sent to Ubyport as host contact.',
    autoSendLabel: 'Auto-submit to Ubyport',
    autoSendEnabled: '✓ Enabled',
    autoSendDisabled: '— Disabled',
    autoSendHintEnabled: 'Guest data will be sent to Ubyport automatically within ~5 min of form completion.',
    autoSendHintDisabled: 'Enable only after apartment Ubyport credentials and IDUB are verified.',
    autoSendAllLabel: 'Send all guests',
    autoSendAllHint: 'Recommended. Every foreign guest of the booking is reported automatically.',
    autoSendMaxLabel: 'Max guests sent automatically per booking',
    autoSendMaxHint: 'The remaining guests wait for you to review and send them manually. Czech guests are not counted (they are not reported).',
    autoSendMaxInvalid: (max) => `Enter a whole number from 1 to ${max} (the apartment's capacity).`,
    autoSendDelayLabel: 'Send automatically on',
    autoSendDelay0: 'Check-in day',
    autoSendDelay1: '1 day after check-in',
    autoSendDelay2: '2 days after check-in',
    autoSendDelay3: '3 days after check-in',
    autoSendDelayHint: 'The law requires foreign guests to be reported within 3 working days of arrival. A later day means less time to fix a rejected registration.',
    autoSendDelayWarning: 'On day 3 there is no time left to correct data that Ubyport rejects — you risk missing the legal deadline.',
    autoSendInvalidSave: 'The Ubyport auto-send settings are not valid. Correct them and save again.',
    dorucenkaHeader: 'Receipts (Dorucenky)',
    dorucenkaDesc: 'Download all Ubyport receipt PDFs for a date range as a ZIP archive. Only one download job can be active at a time. The ZIP is available for 48 hours.',
    dorucenkaLabelFrom: 'From',
    dorucenkaLabelTo: 'To',
    dorucenkaRequesting: 'Requesting…',
    dorucenkaRequest: 'Request Download',
    dorucenkaPending: 'Preparing your download…',
    dorucenkaProcessing: 'Building ZIP archive…',
    dorucenkaLabelRange: 'Range:',
    dorucenkaLabelRequested: 'Requested:',
    dorucenkaEmailNotice: 'We will email you when the files are ready. You can also stay on this page — it will update automatically.',
    dorucenkaReadyHeader: 'Download ready',
    dorucenkaFiles: (count) => `${count} file${count !== 1 ? 's' : ''}`,
    dorucenkaLabelReady: 'Ready:',
    dorucenkaLabelExpires: 'Expires:',
    dorucenkaDownloading: 'Opening…',
    dorucenkaDownload: 'Download ZIP',
    dorucenkaNewRequest: 'New request',
    dorucenkaFailedHeader: 'Download failed',
    dorucenkaTryAgain: 'Try again',
    dorucenkaExpired: (from, to) => `Previous download expired (${from} – ${to}).`,
    dorucenkaExpiredHint: 'Request a new one above.',
    cityTaxHeader: 'City Tax Rates',
    cityTaxDesc: 'Set the nightly city tax per guest for each category. Leave blank if a category is exempt. Guests under 18 at the time of check-in are classified as Children. Guests with a disability card (ZTP/P) are classified as Disabled.',
    fieldCityTaxBankAccount: 'Bank account for tax payment',
    fieldCityTaxVariableSymbol: 'Variable symbol',
    fieldCityTaxContact: 'Payer (contact)',
    cityTaxContactNone: '— Not assigned —',
    fieldCityTaxMailbox: 'Recipient mailbox (Datová schránka)',
    cityTaxMailboxNone: '— Select mailbox —',
    cityTaxMailboxOther: 'Other',
    fieldCityTaxMailboxOtherName: 'Office name',
    fieldCityTaxMailboxOtherDataboxId: 'Databox ID',
    fieldCityTaxMailboxOtherAddress: 'Office address',
    cityTaxMailboxDataboxHint: 'Search for databox ID',
    fieldAdultRate: 'Adult rate (per guest/night)',
    fieldChildRate: 'Child rate (under 18, per guest/night)',
    fieldDisabledRate: 'Disabled rate (ZTP/P card, per guest/night)',
    viewCityTaxReport: 'View City Tax Report →',
    cityTaxCollectionLabel: 'Collect tax online:',
    cityTaxCollectionEnabledText: 'Enabled',
    cityTaxCollectionDisabledText: 'Disabled',
    cityTaxCollectionHint: 'When enabled, the guest must pay the tax by card before the Check-in Guide is shown to them.',
    cityTaxStripeConnectLink: 'Connect in Settings →',
    cityTaxPaymentMethodNone: '— Select account —',
    cityTaxPaymentMethodEmpty: 'You have no Stripe account yet. Add one in Settings → Payment Methods.',
    cityTaxPaymentMethodNotReady: 'The selected Stripe account isn\'t fully set up yet — collection will not work until you finish connecting it.',
    cityTaxPaymentMethodRequiredError: 'Select a fully connected Stripe account to keep online tax collection turned on.',
    cityTaxApplicationFeeNote: 'Service fee {rate} per payment.',
    contactHeader: 'Assigned Contact',
    contactDesc: 'Who handles this apartment. Used for cleaner notifications and guest form footer.',
    contactSourceManager: 'Manager contact',
    contactSourceList: 'Contact list',
    contactSourceOther: 'Other',
    selectContact: '— Select contact —',
    editContactDetails: 'Contact',
    contactReadOnlyHint: 'Edit in Profile → Contacts →',
    fieldContactFullName: 'Full Name',
    fieldContactEmail: 'Email',
    fieldContactPhone: 'Phone',
    fieldContactCompanyName: 'Company name / individual',
    fieldContactIco: 'IČ (company ID)',
    fieldContactAddress: 'Address',
    footerHeader: 'Guest Form Footer',
    footerDesc: 'Choose which contact is shown at the bottom of the guest check-in form.',
    fieldFooterType: 'Show in Guest Form Footer',
    footerTypeManager: 'As section above',
    footerTypeContact: 'Other contact',
    footerContactFullName: 'Other contact - Full Name',
    footerContactEmail: 'Other contact - Email',
    footerContactPhone: 'Other contact - Phone',
    guideIntroTitle: 'What is the Check-in Guide?',
    guideIntroDesc: 'A personalised web page automatically shared with your guests — containing everything they need for a smooth arrival.',
    guideIntroStep1Label: 'Fill in the info',
    guideIntroStep1Desc: 'Add address, WiFi, key access, parking, photos, and any custom instructions.',
    guideIntroStep2Label: 'Guest receives a link',
    guideIntroStep2Desc: 'After the guest submits their registration form, they automatically receive the guide link by email.',
    guideIntroStep3Label: 'Guest sees the guide',
    guideIntroStep3Desc: 'A personal digital guide with apartment details — accessible anytime on their phone.',
    guideSectionSettings: 'Guide Settings',
    guideEnable: 'Enable Check-in Guide for this apartment',
    guideVisibleSections: 'Visible sections',
    guideSecAddress: '📍 Address',
    guideSecKeyAccess: '🔑 Key Access',
    guideSecWifi: '📶 WiFi',
    guideSecParking: '🚗 Parking',
    guideSecHostContact: '📞 Host Contact',
    guideSecDetailedGuide: '📖 Detailed Guide',
    guideSecPhotos: '🖼️ Photos',
    guideSecOtherLinks: '🔗 Other Links',
    guideSecAttentionNotes: '⚠️ Pay Attention',
    guideSecCheckoutInstructions: '🚪 Check-out Instructions',
    guideSecWeather: '🌤️ Weather',
    guideSectionLocation: 'Check-in & Location',
    guideFieldCheckinTime: 'Check-in Time',
    guideFieldCheckoutTime: 'Check-out Time',
    guideFieldAddress: 'Address',
    guideFieldAddressRemark: 'Address Remark',
    guideAddressRemarkPlaceholder: 'e.g. 3rd floor, ring bell #12, gate code 1234',
    guideSectionKeyAccess: 'Key Access',
    guideFieldAccessType: 'Access Type',
    guideAccessTypeSelect: '— Select —',
    guideAccessTypeDoorCode: 'Door Code',
    guideAccessTypeKeybox: 'Key Box',
    guideAccessTypePerson: 'In Person / By Host',
    guideAccessTypeNoKey: 'No Key Needed',
    guideAccessTypeTtlock: '🔐 Smart Lock (TTLock)',
    guideFieldSmartLock: 'Smart Lock',
    guideSelectLock: '— Select lock —',
    guideFieldOfflineFallback: 'Automatically use offline code on failure',
    guideOfflineFallbackHint: 'If PIN generation fails (e.g. the lock has no gateway connection), the system will automatically get a cloud-only offline code that works even without the lock being online.',
    guideFieldKeyCode: 'Key Code',
    guideKeyCodePlaceholder: 'Door/keybox code',
    guidePinVisibleFrom: 'PIN visible from',
    guideCodeVisibleFrom: 'Code visible from',
    guideVisibilityAlways: 'Always visible',
    guideVisibilityFrom: 'Visible from:',
    guidePinHiddenUntil: (time) => `PIN will be hidden until ${time} on the check-in day.`,
    guideCodeHiddenUntil: (time) => `Code will be hidden until ${time} on the check-in day.`,
    guideFieldKeyRemark: 'Key Remark',
    guideKeyRemarkPlaceholder: 'Additional instructions about key/entry',
    guideSectionAmenities: 'Amenities',
    guideFieldWifiName: 'WiFi Network Name',
    guideFieldWifiPassword: 'WiFi Password',
    guideFieldParkingInfo: 'Parking Info',
    guideParkingPlaceholder: 'Parking location, instructions',
    guideFieldParkingPrice: 'Parking Price',
    guideParkingPricePlaceholder: 'e.g. Free, 100 CZK/day',
    guideSectionHostContact: 'Host Contact',
    guideHostName: 'Name',
    guideHostPhone: 'Phone',
    guideHostEmail: 'Email',
    guideSectionGuestInstructions: 'Guest Instructions',
    guideDetailedGuidePlaceholder: 'House rules, appliance instructions, waste disposal, emergency contacts…',
    guideAttentionPlaceholder: 'Important warnings guests should not miss (e.g. don\'t slam the door, no smoking, quiet hours…)',
    guideCheckoutPlaceholder: 'Steps for check-out (e.g. leave keys in box, take out rubbish, close windows…)',
    guideEnglishVersionAdd: '+ Add English version',
    guideEnglishVersionLabel: 'English version (optional)',
    guideEnglishVersionClear: 'Clear',
    guideSectionOtherLinks: 'Other Links',
    guideLinkLabelPlaceholder: 'Label (e.g. YouTube)',
    guideLinkUrlPlaceholder: 'URL',
    guideAddLink: '+ Add Link',
    guideSaving: 'Saving…',
    guideSave: 'Save Guide',
    guideSavedSuccess: 'Check-in guide saved.',
    guideSectionPhotos: 'Photos',
    guidePhotosDesc: 'Upload photos guests will see in the check-in guide (e.g. entrance, key box, parking). Max 10 photos, 10 MB each. Photos are saved immediately.',
    guidePhotoCaption: 'Caption (optional)',
    guidePhotoCaptionPlaceholder: 'e.g. Key box on the right side of the door',
    guidePhotoUploading: (pct) => `Uploading… ${pct}%`,
    guidePhotoAdd: '+ Add Photo',
    guidePhotoFileHint: (used) => `JPEG, PNG, WebP, HEIC accepted · max 10 MB · ${used}/10 used`,
    guidePhotoMaxReached: 'Maximum of 10 photos reached. Delete a photo to upload a new one.',
    guidePhotoConfirmDelete: 'Delete this photo?',
    exportHeader: 'Export Reservations',
    exportDesc: 'Export all reservations and their registered guest data for a date range (by check-in date). CSV includes all fields without signatures. PDF includes a compact table with signatures.',
    exportLabelFrom: 'From',
    exportLabelTo: 'To',
    exportCsvLoading: 'Preparing CSV…',
    exportCsv: '⬇ Export CSV',
    exportPdfLoading: 'Generating PDF…',
    exportPdf: '⬇ Export PDF',
    exportCsvDesc: 'One row per guest slot, all fields, no signature, suitable for spreadsheets.',
    exportCsvBadge: 'Spreadsheet',
    exportPdfDesc: 'Compact landscape table with small inline signatures, optimised for minimum pages.',
    exportPdfBadge: 'With signatures',
    deleteModalHeader: 'Delete Apartment',
    deleteModalDescPre: 'This will permanently delete',
    deleteModalDescPost: 'and all associated data.',
    deleteModalWillDelete: 'The following will be permanently deleted:',
    deleteModalReservations: (count) => `${count} reservation${count !== 1 ? 's' : ''}`,
    deleteModalUbyportSubmitted: (count) => `(${count} submitted to Ubyport)`,
    deleteModalDorucenka: (count) => `${count} Dorucenka PDF${count !== 1 ? 's' : ''} — your proof of Ubyport compliance. Export them before proceeding.`,
    deleteModalCalendars: (count) => `${count} connected calendar${count !== 1 ? 's' : ''}`,
    deleteModalTypeToConfirm: 'Type the apartment name to confirm:',
    cancel: 'Cancel',
    deleting: 'Deleting…',
    deleteConfirm: 'Delete permanently',
  },
  vi: {
    loading: 'Đang tải thông tin căn hộ…',
    loadingGuide: 'Đang tải hướng dẫn…',
    notFound: 'Không tìm thấy căn hộ.',
    back: '← Quay lại danh sách căn hộ',
    subtitle: 'Cấu hình chi tiết căn hộ',
    savedSuccess: 'Đã lưu cài đặt căn hộ thành công.',
    copySuccess: 'Đã sao chép URL check-in.',
    copyError: 'Không thể sao chép URL check-in',
    saving: 'Đang lưu…',
    saveChanges: 'Lưu thay đổi',
    deleteApartment: 'Xóa căn hộ',
    deleteApartmentDescription: 'Thao tác xóa sẽ loại bỏ căn hộ này, các đặt phòng, biểu mẫu khách, lịch đã kết nối và biên nhận đã lưu. Việc xóa không thể hoàn tác trong ứng dụng. Hãy xuất dữ liệu cần giữ và tải biên nhận trước khi tiếp tục. Bước tiếp theo hiển thị tổng quan và yêu cầu xác nhận bằng tên căn hộ.',
    tabGeneral: '⚙️ Chung',
    tabContact: '👤 Liên hệ',
    tabUbyport: '🏛️ Ubyport',
    tabCityTax: '💰 Thuế thành phố',
    tabPayments: '💳 Thanh toán',
    paymentsHeader: 'Thanh toán cho căn hộ này',
    paymentsDesc: 'Chọn tài khoản Stripe đã kết nối cho từng loại thanh toán — hoặc dùng cùng một tài khoản cho tất cả.',
    paymentsPurposeCityTax: 'Thuế lưu trú',
    paymentsPurposeCityTaxHint: 'Nơi nhận thuế lưu trú thu từ khách.',
    paymentsPurposeUpsell: 'Dịch vụ thêm (nhận phòng sớm, trả phòng muộn, gửi hành lý)',
    paymentsPurposeUpsellHint: 'Nơi khách thanh toán cho các dịch vụ thêm vào kỳ lưu trú.',
    paymentsPurposeDeposit: 'Tiền đặt cọc',
    paymentsPurposeDepositHint: 'Thẻ của khách được lưu và khoản đặt cọc được giữ trên tài khoản này.',
    paymentsPurposeNotReady: 'Tài khoản Stripe đã chọn chưa được thiết lập đầy đủ — loại thanh toán này sẽ không hoạt động cho đến khi bạn hoàn tất kết nối.',
    paymentsNoneCityTax: 'Chưa chọn tài khoản — khách không thể trả thuế lưu trú tại đây.',
    paymentsNoneUpsell: 'Chưa chọn tài khoản — khách không thể thanh toán dịch vụ thêm tại đây.',
    paymentsNoneDeposit: 'Chưa chọn tài khoản — không thể thu tiền đặt cọc tại đây.',
    paymentMethodInvalidError: 'Tài khoản Stripe được chọn cho "{purpose}" không phải là tài khoản đã kết nối của bạn. Hãy tải lại trang và chọn lại.',
    cityTaxPaysToAccount: 'Thuế được thu vào {account}.',
    cityTaxNeedsAccount: 'Hãy chọn tài khoản Stripe trước.',
    cityTaxOpenPayments: 'Mở Thanh toán',
    tabCalendar: '📅 Đồng bộ lịch',
    tabGuide: '🏠 Hướng dẫn',
    tabUpsell: '🎁 Dịch vụ thêm',
    tabDeposit: '🔒 Tiền cọc',
    tabBooking: '🌐 Đặt phòng trực tiếp',
    tabExport: '⬇ Xuất dữ liệu',
    fieldInternalName: 'Tên nội bộ',
    fieldDisplayName: 'Tên hiển thị',
    fieldAddress: 'Địa chỉ',
    fieldCapacity: 'Sức chứa',
    fieldDescription: 'Mô tả',
    fieldActive: 'Hoạt động',
    sectionAutomation: 'Tự động hóa',
    badgePublicCheckin: 'Check-in công khai',
    fieldCheckinUrl: 'URL check-in công khai cho khách',
    btnCopy: 'Sao chép',
    checkinUrlHint: 'Chia sẻ URL cố định này trong tin nhắn tự động trên Airbnb/Booking.',
    fieldCheckinWindowDays: 'Khoảng check-in (số ngày trước)',
    checkinWindowHint: (days) => `Khách có thể bắt đầu check-in cho lần đến trong ${days} ngày tới.`,
    documentScanLabel: 'Cho phép khách quét giấy tờ',
    documentScanHint: 'Khách có thể dùng camera điện thoại quét hộ chiếu/CMND để tự động điền biểu mẫu. Khách vẫn kiểm tra và xác nhận mọi thứ trước khi ký.',
    automationInfoTitle: 'Cách tự động hóa đăng ký khách',
    automationStep1Title: '1. Sao chép liên kết',
    automationStep1Desc: 'Sao chép URL check-in công khai cho khách từ ô trên',
    automationStep2Title: '2. Dán vào tin nhắn',
    automationStep2Desc: 'Thêm liên kết vào tin nhắn đặt phòng tự động trong Airbnb / Booking.com',
    automationStep3Title: '3. Khách đặt phòng',
    automationStep3Desc: 'Khách nhận được tin nhắn tự động với liên kết đăng ký',
    automationStep4Title: '4. Khách đăng ký',
    automationStep4Desc: 'Khách điền biểu mẫu check-in với thông tin cá nhân và tài liệu',
    automationStep5Title: '5. Xong!',
    automationStep5Desc: 'Dữ liệu khách được lưu tự động — sẵn sàng để báo cáo Ubyport',
    automationTip: 'Mẹo: Trong Airbnb vào Hộp thư → Tin nhắn đã lên lịch. Trong Booking.com vào Nhắn tin → Tin nhắn tự động. Dán liên kết dưới dạng văn bản thuần túy hoặc siêu liên kết.',
    overbookingTitle: 'Đặt quá mức',
    overbookingDesc: 'Khi hai lịch có lịch đặt trùng nhau, lịch đặt từ lịch có độ ưu tiên cao hơn sẽ thắng và lịch còn lại bị đánh dấu là Đặt quá mức. Sắp xếp lại lịch bên dưới bằng nút ▲ / ▼ — lịch trên cùng luôn thắng. Lịch đặt thủ công luôn có ưu tiên hơn lịch đặt nhập.',
    sectionOverbooking: 'Chiến lược đặt trùng lặp',
    badgeCollision: 'Xử lý xung đột',
    fieldCollisionStrategy: 'Khi phát hiện lịch đặt trùng lặp',
    strategyStrict: 'Nghiêm ngặt',
    strategyFirstWins: 'Ai trước được trước',
    strategyAllow: 'Cho phép',
    strategyStrictDesc: 'Tất cả lịch đặt trùng lặp sẽ không hoạt động.',
    strategyFirstWinsDesc: 'Lịch đặt cũ nhất giữ nguyên, các lịch đặt khác không hoạt động.',
    strategyAllowDesc: 'Tất cả vẫn hoạt động, chỉ thông báo cho quản lý.',
    collisionStrategyHint: 'Áp dụng tự động khi đồng bộ lịch phát hiện trùng lặp. Quyết định thủ công sẽ không bị ghi đè.',
    ubyportCredentialsHeader: 'Thông tin đăng nhập Ubyport của căn hộ',
    ubyportCredentialsDesc: 'Pháp luật Séc yêu cầu chủ nhà ghi lại và gửi dữ liệu cá nhân của khách đến Ubyport. Bạn có thể lấy thông tin đăng nhập (tên đăng nhập, mật khẩu, IDUB) trực tiếp trong tài khoản Ubyport của mình.',
    ubyportGuideLabel: 'Hướng dẫn cài đặt Ubyport? → Xem hướng dẫn',
    fieldUbyportUsername: 'Tên người dùng Ubyport',
    ubyportUsernameHint: 'Tên đăng nhập dịch vụ web Ubyport (Webservice). Phải bắt đầu bằng tiền tố UBY-WS_.',
    ubyportUsernameWarning: 'Tên đăng nhập này có thể không hoạt động cho việc gửi tự động — thông tin đăng nhập dịch vụ web phải bắt đầu bằng UBY-WS_. Xem hướng dẫn ở trên để biết thêm chi tiết.',
    ubyportUsernamePlaceholder: 'UBY-WS_XXXXX',
    fieldUbyportPassword: 'Mật khẩu Ubyport',
    ubyportPasswordPlaceholderSet: 'Mật khẩu đã lưu sẽ giữ nguyên trừ khi bạn nhập mới',
    ubyportPasswordPlaceholderEmpty: 'Nhập mật khẩu căn hộ',
    ubyportPasswordHintSet: 'Đã có mật khẩu được lưu. Để trống để giữ nguyên.',
    ubyportPasswordHintEmpty: 'Chưa có mật khẩu nào được lưu.',
    ubyportTestButton: 'Kiểm tra thông tin đăng nhập',
    ubyportTestRunning: 'Đang kiểm tra…',
    ubyportTestOk: 'Thông tin đăng nhập hợp lệ',
    ubyportTestInvalid: 'Ubyport từ chối tên đăng nhập hoặc mật khẩu. Thử sai nhiều lần có thể làm khóa tài khoản.',
    ubyportTestIncomplete: 'Hãy nhập tên đăng nhập và mật khẩu',
    ubyportTestTimeout: 'Ubyport không phản hồi, hãy thử lại',
    ubyportTestUnreachable: 'Không kết nối được tới Ubyport, hãy thử lại',
    ubyportTestProviderError: 'Ubyport trả về lỗi, hãy thử lại sau',
    ubyportTestNotConfigured: 'Nền tảng chưa thiết lập Ubyport. Vui lòng liên hệ hỗ trợ',
    ubyportTestBusy: 'Một lần kiểm tra đang chạy',
    ubyportTestRateLimited: 'Kiểm tra quá nhiều lần, hãy đợi một lát',
    ubyportTestFillIn: 'Hãy điền',
    ubyportTestFieldUsername: 'tên đăng nhập',
    ubyportTestFieldPassword: 'mật khẩu',
    ubyportTestFieldIdub: 'IDUB',
    ubyportTestFailed: 'Không thể thực hiện kiểm tra, hãy thử lại',
    fieldIdub: 'IDUB',
    fieldShortName: 'Mã định danh Ubyport',
    shortNameHint: 'Phần bên phải dấu gạch dưới trong tên đăng nhập Ubyport. Nếu tên đăng nhập là UBY-WS_XXXXX, nhập XXXXX. Tối đa 10 ký tự.',
    shortNamePlaceholder: 'XXXXX (từ UBY‑WS_XXXXX)',
    fieldHostFullName: 'Họ và tên chủ nhà',
    fieldHostContact: 'Liên hệ chủ nhà',
    hostContactPlaceholder: 'Số điện thoại hoặc email',
    hostContactHint: 'Điện thoại hoặc email gửi đến Ubyport làm thông tin liên hệ chủ nhà.',
    autoSendLabel: 'Tự động gửi lên Ubyport',
    autoSendEnabled: '✓ Đã bật',
    autoSendDisabled: '— Đã tắt',
    autoSendHintEnabled: 'Dữ liệu khách sẽ được gửi lên Ubyport tự động trong vòng ~5 phút sau khi hoàn thành biểu mẫu.',
    autoSendHintDisabled: 'Chỉ bật sau khi xác minh thông tin đăng nhập Ubyport và IDUB của căn hộ.',
    autoSendAllLabel: 'Gửi tất cả khách',
    autoSendAllHint: 'Nên dùng. Mọi khách nước ngoài của đặt phòng đều được khai báo tự động.',
    autoSendMaxLabel: 'Số khách tối đa được gửi tự động cho mỗi đặt phòng',
    autoSendMaxHint: 'Những khách còn lại sẽ chờ bạn kiểm tra và gửi thủ công. Khách Séc không được tính (họ không phải khai báo).',
    autoSendMaxInvalid: (max) => `Nhập một số nguyên từ 1 đến ${max} (sức chứa của căn hộ).`,
    autoSendDelayLabel: 'Gửi tự động vào',
    autoSendDelay0: 'Ngày nhận phòng',
    autoSendDelay1: '1 ngày sau khi nhận phòng',
    autoSendDelay2: '2 ngày sau khi nhận phòng',
    autoSendDelay3: '3 ngày sau khi nhận phòng',
    autoSendDelayHint: 'Luật yêu cầu khai báo khách nước ngoài trong vòng 3 ngày làm việc kể từ khi đến. Gửi muộn hơn nghĩa là có ít thời gian hơn để sửa một đăng ký bị từ chối.',
    autoSendDelayWarning: 'Vào ngày thứ 3 không còn thời gian để sửa dữ liệu bị Ubyport từ chối — bạn có nguy cơ lỡ hạn theo luật định.',
    autoSendInvalidSave: 'Cài đặt gửi tự động lên Ubyport không hợp lệ. Hãy sửa và lưu lại.',
    dorucenkaHeader: 'Biên lai (Dorucenky)',
    dorucenkaDesc: 'Tải xuống tất cả PDF biên lai Ubyport cho một khoảng ngày dưới dạng file ZIP. Chỉ có thể có một công việc tải xuống đang hoạt động. File ZIP khả dụng trong 48 giờ.',
    dorucenkaLabelFrom: 'Từ ngày',
    dorucenkaLabelTo: 'Đến ngày',
    dorucenkaRequesting: 'Đang yêu cầu…',
    dorucenkaRequest: 'Yêu cầu tải xuống',
    dorucenkaPending: 'Đang chuẩn bị tải xuống…',
    dorucenkaProcessing: 'Đang tạo file ZIP…',
    dorucenkaLabelRange: 'Khoảng thời gian:',
    dorucenkaLabelRequested: 'Đã yêu cầu:',
    dorucenkaEmailNotice: 'Chúng tôi sẽ gửi email khi các tệp đã sẵn sàng. Bạn cũng có thể ở lại trang này — nó sẽ tự động cập nhật.',
    dorucenkaReadyHeader: 'Sẵn sàng tải xuống',
    dorucenkaFiles: (count) => `${count} tệp`,
    dorucenkaLabelReady: 'Sẵn sàng:',
    dorucenkaLabelExpires: 'Hết hạn:',
    dorucenkaDownloading: 'Đang mở…',
    dorucenkaDownload: 'Tải xuống ZIP',
    dorucenkaNewRequest: 'Yêu cầu mới',
    dorucenkaFailedHeader: 'Tải xuống thất bại',
    dorucenkaTryAgain: 'Thử lại',
    dorucenkaExpired: (from, to) => `Lần tải xuống trước đã hết hạn (${from} – ${to}).`,
    dorucenkaExpiredHint: 'Yêu cầu mới ở trên.',
    cityTaxHeader: 'Mức thuế thành phố',
    cityTaxDesc: 'Đặt thuế thành phố mỗi đêm mỗi khách theo từng danh mục. Để trống nếu danh mục được miễn thuế. Khách dưới 18 tuổi khi nhận phòng được phân loại là Trẻ em. Khách có thẻ khuyết tật (ZTP/P) được phân loại là Người khuyết tật.',
    fieldCityTaxBankAccount: 'Số tài khoản để nộp thuế',
    fieldCityTaxVariableSymbol: 'Ký hiệu biến',
    fieldCityTaxContact: 'Người nộp thuế (liên hệ)',
    cityTaxContactNone: '— Chưa chỉ định —',
    fieldCityTaxMailbox: 'Hộp thư người nhận',
    cityTaxMailboxNone: '— Chọn hộp thư —',
    cityTaxMailboxOther: 'Khác',
    fieldCityTaxMailboxOtherName: 'Tên cơ quan',
    fieldCityTaxMailboxOtherDataboxId: 'ID hộp thư',
    fieldCityTaxMailboxOtherAddress: 'Địa chỉ cơ quan',
    cityTaxMailboxDataboxHint: 'Tìm ID hộp thư',
    fieldAdultRate: 'Mức người lớn (mỗi khách/đêm)',
    fieldChildRate: 'Mức trẻ em (dưới 18 tuổi, mỗi khách/đêm)',
    fieldDisabledRate: 'Mức người khuyết tật (thẻ ZTP/P, mỗi khách/đêm)',
    viewCityTaxReport: 'Xem báo cáo thuế thành phố →',
    cityTaxCollectionLabel: 'Thu thuế trực tuyến:',
    cityTaxCollectionEnabledText: 'Đã bật',
    cityTaxCollectionDisabledText: 'Đã tắt',
    cityTaxCollectionHint: 'Khi bật, khách phải thanh toán thuế bằng thẻ trước khi được xem hướng dẫn nhận phòng.',
    cityTaxStripeConnectLink: 'Kết nối trong Cài đặt →',
    cityTaxPaymentMethodNone: '— Chọn tài khoản —',
    cityTaxPaymentMethodEmpty: 'Bạn chưa có tài khoản Stripe nào. Thêm tại Cài đặt → Phương thức thanh toán.',
    cityTaxPaymentMethodNotReady: 'Tài khoản Stripe đã chọn chưa được thiết lập đầy đủ — việc thu thuế sẽ không hoạt động cho đến khi bạn hoàn tất kết nối.',
    cityTaxPaymentMethodRequiredError: 'Hãy chọn một tài khoản Stripe đã kết nối đầy đủ để giữ tính năng thu thuế trực tuyến bật.',
    cityTaxApplicationFeeNote: 'Phí dịch vụ {rate} trên mỗi giao dịch thanh toán.',
    contactHeader: 'Người liên hệ được phân công',
    contactDesc: 'Người quản lý căn hộ này. Dùng cho thông báo nhân viên dọn phòng và chân trang biểu mẫu khách.',
    contactSourceManager: 'Liên hệ quản lý',
    contactSourceList: 'Danh sách liên hệ',
    contactSourceOther: 'Khác',
    selectContact: '— Chọn liên hệ —',
    editContactDetails: 'Liên hệ',
    contactReadOnlyHint: 'Chỉnh sửa trong Hồ sơ → Liên hệ →',
    fieldContactFullName: 'Họ và tên',
    fieldContactEmail: 'Email',
    fieldContactPhone: 'Điện thoại',
    fieldContactCompanyName: 'Tên công ty / cá nhân',
    fieldContactIco: 'IČ (mã công ty)',
    fieldContactAddress: 'Địa chỉ',
    footerHeader: 'Chân trang biểu mẫu khách',
    footerDesc: 'Chọn liên hệ nào hiển thị ở cuối biểu mẫu check-in của khách.',
    fieldFooterType: 'Hiển thị trong chân trang biểu mẫu khách',
    footerTypeManager: 'Theo cài đặt ở trên',
    footerTypeContact: 'Liên hệ khác',
    footerContactFullName: 'Liên hệ khác - Họ và tên',
    footerContactEmail: 'Liên hệ khác - Email',
    footerContactPhone: 'Liên hệ khác - Điện thoại',
    guideIntroTitle: 'Hướng dẫn nhận phòng là gì?',
    guideIntroDesc: 'Trang web cá nhân hóa tự động chia sẻ với khách của bạn — chứa mọi thứ cần thiết để nhận phòng suôn sẻ.',
    guideIntroStep1Label: 'Điền thông tin',
    guideIntroStep1Desc: 'Thêm địa chỉ, WiFi, cách lấy chìa khóa, bãi đậu xe, ảnh và hướng dẫn tùy chỉnh.',
    guideIntroStep2Label: 'Khách nhận được liên kết',
    guideIntroStep2Desc: 'Sau khi khách gửi biểu mẫu đăng ký, họ sẽ tự động nhận được liên kết hướng dẫn qua email.',
    guideIntroStep3Label: 'Khách xem hướng dẫn',
    guideIntroStep3Desc: 'Hướng dẫn kỹ thuật số cá nhân với thông tin căn hộ — có thể truy cập bất cứ lúc nào trên điện thoại.',
    guideSectionSettings: 'Cài đặt hướng dẫn',
    guideEnable: 'Bật hướng dẫn check-in cho căn hộ này',
    guideVisibleSections: 'Các phần hiển thị',
    guideSecAddress: '📍 Địa chỉ',
    guideSecKeyAccess: '🔑 Truy cập bằng chìa khóa',
    guideSecWifi: '📶 WiFi',
    guideSecParking: '🚗 Đỗ xe',
    guideSecHostContact: '📞 Liên hệ chủ nhà',
    guideSecDetailedGuide: '📖 Hướng dẫn chi tiết',
    guideSecPhotos: '🖼️ Ảnh',
    guideSecOtherLinks: '🔗 Liên kết khác',
    guideSecAttentionNotes: '⚠️ Lưu ý quan trọng',
    guideSecCheckoutInstructions: '🚪 Hướng dẫn trả phòng',
    guideSecWeather: '🌤️ Thời tiết',
    guideSectionLocation: 'Check-in & Vị trí',
    guideFieldCheckinTime: 'Giờ nhận phòng',
    guideFieldCheckoutTime: 'Giờ trả phòng',
    guideFieldAddress: 'Địa chỉ',
    guideFieldAddressRemark: 'Ghi chú địa chỉ',
    guideAddressRemarkPlaceholder: 'ví dụ: Tầng 3, bấm chuông số 12, mã cổng 1234',
    guideSectionKeyAccess: 'Truy cập bằng chìa khóa',
    guideFieldAccessType: 'Loại truy cập',
    guideAccessTypeSelect: '— Chọn —',
    guideAccessTypeDoorCode: 'Mã cửa',
    guideAccessTypeKeybox: 'Hộp chìa khóa',
    guideAccessTypePerson: 'Trực tiếp / Từ chủ nhà',
    guideAccessTypeNoKey: 'Không cần chìa khóa',
    guideAccessTypeTtlock: '🔐 Khóa thông minh (TTLock)',
    guideFieldSmartLock: 'Khóa thông minh',
    guideSelectLock: '— Chọn khóa —',
    guideFieldOfflineFallback: 'Tự động dùng mã offline khi thất bại',
    guideOfflineFallbackHint: 'Nếu việc tạo PIN thất bại (ví dụ khóa không kết nối với cổng), hệ thống sẽ tự động lấy mã offline từ cloud — hoạt động được ngay cả khi khóa không trực tuyến.',
    guideFieldKeyCode: 'Mã chìa khóa',
    guideKeyCodePlaceholder: 'Mã cửa/hộp chìa khóa',
    guidePinVisibleFrom: 'PIN hiển thị từ',
    guideCodeVisibleFrom: 'Mã hiển thị từ',
    guideVisibilityAlways: 'Luôn hiển thị',
    guideVisibilityFrom: 'Hiển thị từ:',
    guidePinHiddenUntil: (time) => `PIN sẽ bị ẩn cho đến ${time} vào ngày nhận phòng.`,
    guideCodeHiddenUntil: (time) => `Mã sẽ bị ẩn cho đến ${time} vào ngày nhận phòng.`,
    guideFieldKeyRemark: 'Ghi chú về chìa khóa',
    guideKeyRemarkPlaceholder: 'Hướng dẫn bổ sung về chìa khóa/lối vào',
    guideSectionAmenities: 'Tiện nghi',
    guideFieldWifiName: 'Tên mạng WiFi',
    guideFieldWifiPassword: 'Mật khẩu WiFi',
    guideFieldParkingInfo: 'Thông tin đỗ xe',
    guideParkingPlaceholder: 'Vị trí đỗ xe, hướng dẫn',
    guideFieldParkingPrice: 'Giá đỗ xe',
    guideParkingPricePlaceholder: 'ví dụ: Miễn phí, 100 CZK/ngày',
    guideSectionHostContact: 'Liên hệ chủ nhà',
    guideHostName: 'Tên',
    guideHostPhone: 'Điện thoại',
    guideHostEmail: 'Email',
    guideSectionGuestInstructions: 'Hướng dẫn cho khách',
    guideDetailedGuidePlaceholder: 'Nội quy nhà, hướng dẫn thiết bị, xử lý rác thải, số khẩn cấp…',
    guideAttentionPlaceholder: 'Cảnh báo quan trọng khách không được bỏ qua (ví dụ: không đóng cửa mạnh, cấm hút thuốc, giờ yên tĩnh…)',
    guideCheckoutPlaceholder: 'Các bước trả phòng (ví dụ: để chìa khóa trong hộp, đổ rác, đóng cửa sổ…)',
    guideEnglishVersionAdd: '+ Thêm bản tiếng Anh',
    guideEnglishVersionLabel: 'Bản tiếng Anh (tùy chọn)',
    guideEnglishVersionClear: 'Xóa',
    guideSectionOtherLinks: 'Liên kết khác',
    guideLinkLabelPlaceholder: 'Nhãn (ví dụ: YouTube)',
    guideLinkUrlPlaceholder: 'URL',
    guideAddLink: '+ Thêm liên kết',
    guideSaving: 'Đang lưu…',
    guideSave: 'Lưu hướng dẫn',
    guideSavedSuccess: 'Đã lưu hướng dẫn check-in.',
    guideSectionPhotos: 'Ảnh',
    guidePhotosDesc: 'Tải lên ảnh khách sẽ thấy trong hướng dẫn check-in (ví dụ: lối vào, hộp chìa khóa, bãi đỗ xe). Tối đa 10 ảnh, mỗi ảnh tối đa 10 MB. Ảnh được lưu ngay lập tức.',
    guidePhotoCaption: 'Chú thích (tùy chọn)',
    guidePhotoCaptionPlaceholder: 'ví dụ: Hộp chìa khóa ở bên phải cửa',
    guidePhotoUploading: (pct) => `Đang tải lên… ${pct}%`,
    guidePhotoAdd: '+ Thêm ảnh',
    guidePhotoFileHint: (used) => `JPEG, PNG, WebP, HEIC · tối đa 10 MB · ${used}/10 đã dùng`,
    guidePhotoMaxReached: 'Đã đạt tối đa 10 ảnh. Xóa một ảnh để tải lên ảnh mới.',
    guidePhotoConfirmDelete: 'Xóa ảnh này?',
    exportHeader: 'Xuất lịch đặt',
    exportDesc: 'Xuất tất cả lịch đặt và dữ liệu khách đã đăng ký cho một khoảng ngày (theo ngày nhận phòng). CSV bao gồm tất cả các trường không có chữ ký. PDF bao gồm bảng gọn với chữ ký.',
    exportLabelFrom: 'Từ ngày',
    exportLabelTo: 'Đến ngày',
    exportCsvLoading: 'Đang chuẩn bị CSV…',
    exportCsv: '⬇ Xuất CSV',
    exportPdfLoading: 'Đang tạo PDF…',
    exportPdf: '⬇ Xuất PDF',
    exportCsvDesc: 'Một hàng mỗi ô khách, tất cả các trường, không có chữ ký, phù hợp cho bảng tính.',
    exportCsvBadge: 'Bảng tính',
    exportPdfDesc: 'Bảng ngang gọn với chữ ký nhỏ nội tuyến, tối ưu hóa số trang tối thiểu.',
    exportPdfBadge: 'Có chữ ký',
    deleteModalHeader: 'Xóa căn hộ',
    deleteModalDescPre: 'Thao tác này sẽ xóa vĩnh viễn',
    deleteModalDescPost: 'và tất cả dữ liệu liên quan.',
    deleteModalWillDelete: 'Những dữ liệu sau sẽ bị xóa vĩnh viễn:',
    deleteModalReservations: (count) => `${count} lịch đặt`,
    deleteModalUbyportSubmitted: (count) => `(${count} đã gửi lên Ubyport)`,
    deleteModalDorucenka: (count) => `${count} PDF biên lai Dorucenka — bằng chứng tuân thủ Ubyport của bạn. Hãy xuất chúng trước khi tiếp tục.`,
    deleteModalCalendars: (count) => `${count} lịch đã kết nối`,
    deleteModalTypeToConfirm: 'Nhập tên căn hộ để xác nhận:',
    cancel: 'Hủy',
    deleting: 'Đang xóa…',
    deleteConfirm: 'Xóa vĩnh viễn',
  },
  uk: {
    loading: 'Завантаження деталей апартаменту…',
    loadingGuide: 'Завантаження гіда…',
    notFound: 'Апартамент не знайдено.',
    back: '← Назад до апартаментів',
    subtitle: 'Конфігурація апартаменту',
    savedSuccess: 'Налаштування апартаменту збережено.',
    copySuccess: 'URL check-in скопійовано.',
    copyError: 'Не вдалося скопіювати URL check-in',
    saving: 'Збереження…',
    saveChanges: 'Зберегти зміни',
    deleteApartment: 'Видалити апартамент',
    deleteApartmentDescription: 'Видалення прибере цей апартамент, його бронювання, форми гостей, підключені календарі та збережені квитанції. Видалення неможливо скасувати в застосунку. Перед продовженням експортуйте потрібні дані та завантажте квитанції. Наступний крок покаже підсумок і попросить підтвердити дію назвою апартаменту.',
    tabGeneral: '⚙️ Загальне',
    tabContact: '👤 Контакт',
    tabUbyport: '🏛️ Ubyport',
    tabCityTax: '💰 Туристичний збір',
    tabPayments: '💳 Платежі',
    paymentsHeader: 'Платежі за ці апартаменти',
    paymentsDesc: 'Для кожного виду платежів можна вибрати свій підключений Stripe-рахунок — або той самий для всіх.',
    paymentsPurposeCityTax: 'Туристичний збір',
    paymentsPurposeCityTaxHint: 'Сюди надходить туристичний збір, який сплачують гості.',
    paymentsPurposeUpsell: 'Додаткові послуги (ранній заїзд, пізній виїзд, зберігання багажу)',
    paymentsPurposeUpsellHint: 'Сюди гості платять за додаткові послуги до свого проживання.',
    paymentsPurposeDeposit: 'Депозит',
    paymentsPurposeDepositHint: 'На цьому рахунку зберігається картка гостя та резервується депозит.',
    paymentsPurposeNotReady: 'Вибраний Stripe-рахунок ще не повністю налаштований — платежі цього виду не працюватимуть, доки ви не завершите підключення.',
    paymentsNoneCityTax: 'Рахунок не обрано — гості не зможуть сплатити туристичний збір.',
    paymentsNoneUpsell: 'Рахунок не обрано — гості не зможуть оплатити додаткові послуги.',
    paymentsNoneDeposit: 'Рахунок не обрано — депозит тут стягнути неможливо.',
    paymentMethodInvalidError: 'Stripe-рахунок, обраний для «{purpose}», не є вашим підключеним рахунком. Перезавантажте сторінку та виберіть його знову.',
    cityTaxPaysToAccount: 'Збір надходить на {account}.',
    cityTaxNeedsAccount: 'Спочатку оберіть Stripe-рахунок.',
    cityTaxOpenPayments: 'Відкрити Платежі',
    tabCalendar: '📅 Синхронізація календаря',
    tabGuide: '🏠 Путівник',
    tabUpsell: '🎁 Додаткові послуги',
    tabDeposit: '🔒 Застава',
    tabBooking: '🌐 Пряме бронювання',
    tabExport: '⬇ Експорт',
    fieldInternalName: 'Внутрішня назва',
    fieldDisplayName: 'Відображувана назва',
    fieldAddress: 'Адреса',
    fieldCapacity: 'Місткість',
    fieldDescription: 'Опис',
    fieldActive: 'Активний',
    sectionAutomation: 'Автоматизація',
    badgePublicCheckin: 'Публічний check-in',
    fieldCheckinUrl: 'Публічна URL для check-in гостей',
    btnCopy: 'Копіювати',
    checkinUrlHint: 'Поділіться цією постійною URL в автоматичному повідомленні на Airbnb/Booking.',
    fieldCheckinWindowDays: 'Вікно check-in (днів наперед)',
    checkinWindowHint: (days) => `Гості можуть розпочати check-in для заїзду від сьогодні до ${days} днів наперед.`,
    documentScanLabel: 'Дозволити гостям сканувати документ',
    documentScanHint: 'Гості можуть відсканувати паспорт/посвідчення камерою телефону, щоб автоматично заповнити форму. Перед підписом вони все одно все перевіряють і підтверджують.',
    automationInfoTitle: 'Як автоматизувати реєстрацію гостей',
    automationStep1Title: '1. Скопіюйте посилання',
    automationStep1Desc: 'Скопіюйте публічний URL для check-in гостей із поля вище',
    automationStep2Title: '2. Вставте у повідомлення',
    automationStep2Desc: 'Додайте посилання до вашого автоматичного повідомлення в Airbnb / Booking.com',
    automationStep3Title: '3. Гість бронює',
    automationStep3Desc: 'Гість отримує ваше автоматичне повідомлення з посиланням для реєстрації',
    automationStep4Title: '4. Гість реєструється',
    automationStep4Desc: 'Гість заповнює форму check-in зі своїми особистими даними та документами',
    automationStep5Title: '5. Готово!',
    automationStep5Desc: 'Дані гостя автоматично збережені — готові для звітності Ubyport',
    automationTip: 'Порада: В Airbnb перейдіть до Вхідні → Заплановані повідомлення. У Booking.com перейдіть до Повідомлення → Автоповідомлення. Вставте посилання як простий текст або гіперпосилання.',
    overbookingTitle: 'Перебронювання',
    overbookingDesc: 'Коли два календарі мають накладені бронювання, бронювання з календаря вищого пріоритету виграє, а інше позначається як Перебронювання. Змінюйте порядок календарів нижче за допомогою кнопок ▲ / ▼ — верхній календар завжди виграє. Ручні бронювання завжди мають пріоритет над імпортованими.',
    sectionOverbooking: 'Стратегія перебронювання',
    badgeCollision: 'Вирішення конфліктів',
    fieldCollisionStrategy: 'При виявленні бронювань, що перекриваються',
    strategyStrict: 'Суворо',
    strategyFirstWins: 'Перший виграє',
    strategyAllow: 'Дозволити',
    strategyStrictDesc: 'Всі бронювання, що перекриваються, стають неактивними.',
    strategyFirstWinsDesc: 'Найстаріше бронювання залишається активним, інші стають неактивними.',
    strategyAllowDesc: 'Всі залишаються активними, менеджер лише отримує сповіщення.',
    collisionStrategyHint: 'Застосовується автоматично при виявленні перекрить під час синхронізації календаря. Ручні рішення ніколи не перезаписуються.',
    ubyportCredentialsHeader: 'Облікові дані Ubyport апартаменту',
    ubyportCredentialsDesc: 'Законодавство Чехії зобов\'язує орендодавців реєструвати та надсилати особисті дані гостей до Ubyport. Дані для входу (логін, пароль, IDUB) можна отримати безпосередньо у своєму акаунті Ubyport.',
    ubyportGuideLabel: 'Як налаштувати Ubyport? → Посібник',
    fieldUbyportUsername: 'Ім\'я користувача Ubyport',
    ubyportUsernameHint: 'Ім\'я користувача веб-служби Ubyport (Webservice). Має починатися з префікса UBY-WS_.',
    ubyportUsernameWarning: 'Цей логін може не працювати для автоматичного надсилання — облікові дані веб-служби повинні починатися з UBY-WS_. Докладніше дивіться в посібнику вище.',
    ubyportUsernamePlaceholder: 'UBY-WS_XXXXX',
    fieldUbyportPassword: 'Пароль Ubyport',
    ubyportPasswordPlaceholderSet: 'Збережений секрет зберігатиметься, якщо не введете новий',
    ubyportPasswordPlaceholderEmpty: 'Введіть секрет апартаменту',
    ubyportPasswordHintSet: 'Секрет вже збережено. Залиште порожнім, щоб зберегти незмінним.',
    ubyportPasswordHintEmpty: 'Секрет апартаменту ще не збережено.',
    ubyportTestButton: 'Перевірити облікові дані',
    ubyportTestRunning: 'Перевірка…',
    ubyportTestOk: 'Облікові дані прийнято',
    ubyportTestInvalid: 'Ubyport відхилив ім’я користувача або пароль. Повторні невдалі спроби можуть заблокувати акаунт.',
    ubyportTestIncomplete: 'Введіть ім’я користувача і пароль',
    ubyportTestTimeout: 'Ubyport не відповів, спробуйте ще раз',
    ubyportTestUnreachable: 'Не вдалося під’єднатися до Ubyport, спробуйте ще раз',
    ubyportTestProviderError: 'Ubyport повернув помилку, спробуйте пізніше',
    ubyportTestNotConfigured: 'Ubyport на платформі ще не налаштовано. Зверніться до підтримки',
    ubyportTestBusy: 'Перевірка вже триває',
    ubyportTestRateLimited: 'Забагато перевірок, зачекайте хвилину',
    ubyportTestFillIn: 'Заповніть',
    ubyportTestFieldUsername: 'ім’я користувача',
    ubyportTestFieldPassword: 'пароль',
    ubyportTestFieldIdub: 'IDUB',
    ubyportTestFailed: 'Не вдалося виконати перевірку, спробуйте ще раз',
    fieldIdub: 'IDUB',
    fieldShortName: 'Ідентифікатор Ubyport',
    shortNameHint: 'Права частина імені користувача після підкреслення. Якщо ім\'я — UBY-WS_XXXXX, введіть XXXXX. Макс 10 символів.',
    shortNamePlaceholder: 'XXXXX (з UBY‑WS_XXXXX)',
    fieldHostFullName: 'Повне ім\'я господаря',
    fieldHostContact: 'Контакт господаря',
    hostContactPlaceholder: 'Номер телефону або email',
    hostContactHint: 'Телефон або email, що відправляється в Ubyport як контакт господаря.',
    autoSendLabel: 'Автоматичне надсилання в Ubyport',
    autoSendEnabled: '✓ Увімкнено',
    autoSendDisabled: '— Вимкнено',
    autoSendHintEnabled: 'Дані гостей будуть автоматично надіслані в Ubyport протягом ~5 хв після заповнення форми.',
    autoSendHintDisabled: 'Увімкніть лише після перевірки облікових даних Ubyport та IDUB апартаменту.',
    autoSendAllLabel: 'Надсилати всіх гостей',
    autoSendAllHint: 'Рекомендовано. Усі іноземні гості бронювання подаються автоматично.',
    autoSendMaxLabel: 'Макс. гостей, що надсилаються автоматично на бронювання',
    autoSendMaxHint: 'Решта гостей чекає, поки ви перевірите та надішлете їх вручну. Чеські гості не враховуються (їх не подають).',
    autoSendMaxInvalid: (max) => `Введіть ціле число від 1 до ${max} (місткість квартири).`,
    autoSendDelayLabel: 'Надсилати автоматично',
    autoSendDelay0: 'у день заїзду',
    autoSendDelay1: 'через 1 день після заїзду',
    autoSendDelay2: 'через 2 дні після заїзду',
    autoSendDelay3: 'через 3 дні після заїзду',
    autoSendDelayHint: 'Закон вимагає подати іноземних гостей протягом 3 робочих днів після прибуття. Пізніший день означає менше часу на виправлення відхиленої реєстрації.',
    autoSendDelayWarning: 'На 3-й день не лишається часу виправити дані, які відхилив Ubyport, — ви ризикуєте пропустити законний строк.',
    autoSendInvalidSave: 'Налаштування автоматичного надсилання в Ubyport недійсні. Виправте їх і збережіть ще раз.',
    dorucenkaHeader: 'Квитанції (Doručenky)',
    dorucenkaDesc: 'Завантажте всі PDF-квитанції Ubyport за вибраний період у вигляді ZIP-архіву. Одночасно може бути активне лише одне завдання завантаження. ZIP доступний протягом 48 годин.',
    dorucenkaLabelFrom: 'Від',
    dorucenkaLabelTo: 'До',
    dorucenkaRequesting: 'Запитую…',
    dorucenkaRequest: 'Запитати завантаження',
    dorucenkaPending: 'Підготовка завантаження…',
    dorucenkaProcessing: 'Створення ZIP-архіву…',
    dorucenkaLabelRange: 'Період:',
    dorucenkaLabelRequested: 'Запитано:',
    dorucenkaEmailNotice: 'Ми надішлемо email, коли файли будуть готові. Ви також можете залишитися на цій сторінці — вона оновиться автоматично.',
    dorucenkaReadyHeader: 'Завантаження готове',
    dorucenkaFiles: (count) => `${count} файл${count === 1 ? '' : count >= 2 && count <= 4 ? 'и' : 'ів'}`,
    dorucenkaLabelReady: 'Готово:',
    dorucenkaLabelExpires: 'Спливає:',
    dorucenkaDownloading: 'Відкриваю…',
    dorucenkaDownload: 'Завантажити ZIP',
    dorucenkaNewRequest: 'Новий запит',
    dorucenkaFailedHeader: 'Завантаження не вдалося',
    dorucenkaTryAgain: 'Спробувати знову',
    dorucenkaExpired: (from, to) => `Попереднє завантаження застаріло (${from} – ${to}).`,
    dorucenkaExpiredHint: 'Зробіть новий запит вище.',
    cityTaxHeader: 'Ставки туристичного збору',
    cityTaxDesc: 'Встановіть нічний туристичний збір на гостя для кожної категорії. Залиште порожнім, якщо категорія звільнена. Гості молодші 18 років на момент заїзду класифікуються як Діти. Гості з карткою інвалідності (ZTP/P) класифікуються як Особи з інвалідністю.',
    fieldCityTaxBankAccount: 'Номер рахунку для сплати збору',
    fieldCityTaxVariableSymbol: 'Змінний символ',
    fieldCityTaxContact: 'Платник (контакт)',
    cityTaxContactNone: '— Не призначено —',
    fieldCityTaxMailbox: 'Поштова скринька одержувача',
    cityTaxMailboxNone: '— Оберіть скриньку —',
    cityTaxMailboxOther: 'Інша',
    fieldCityTaxMailboxOtherName: 'Назва установи',
    fieldCityTaxMailboxOtherDataboxId: 'ID поштової скриньки',
    fieldCityTaxMailboxOtherAddress: 'Адреса установи',
    cityTaxMailboxDataboxHint: 'Пошук ID скриньки',
    fieldAdultRate: 'Ставка для дорослих (на гостя/ніч)',
    fieldChildRate: 'Ставка для дітей (до 18 років, на гостя/ніч)',
    fieldDisabledRate: 'Ставка для осіб з інвалідністю (картка ZTP/P, на гостя/ніч)',
    viewCityTaxReport: 'Переглянути звіт з туристичного збору →',
    cityTaxCollectionLabel: 'Онлайн-збір податку:',
    cityTaxCollectionEnabledText: 'Увімкнено',
    cityTaxCollectionDisabledText: 'Вимкнено',
    cityTaxCollectionHint: 'Якщо увімкнено, гість повинен оплатити збір карткою, перш ніж йому буде показано путівник по заселенню.',
    cityTaxStripeConnectLink: 'Підключити в Налаштуваннях →',
    cityTaxPaymentMethodNone: '— Виберіть акаунт —',
    cityTaxPaymentMethodEmpty: 'У вас ще немає акаунту Stripe. Додайте його в Налаштування → Способи оплати.',
    cityTaxPaymentMethodNotReady: 'Вибраний акаунт Stripe ще не повністю налаштований — збір не працюватиме, доки ви не завершите підключення.',
    cityTaxPaymentMethodRequiredError: 'Виберіть повністю підключений акаунт Stripe, щоб залишити онлайн-збір податку увімкненим.',
    cityTaxApplicationFeeNote: 'Сервісний збір {rate} з кожного платежу.',
    contactHeader: 'Призначений контакт',
    contactDesc: 'Хто керує цим апартаментом. Використовується для сповіщень прибиральників та підвалу форми гостя.',
    contactSourceManager: 'Контакт менеджера',
    contactSourceList: 'Список контактів',
    contactSourceOther: 'Інший',
    selectContact: '— Оберіть контакт —',
    editContactDetails: 'Контакт',
    contactReadOnlyHint: 'Редагувати в Профілі → Контакти →',
    fieldContactFullName: 'Повне ім\'я',
    fieldContactEmail: 'Email',
    fieldContactPhone: 'Телефон',
    fieldContactCompanyName: 'Назва компанії / фізична особа',
    fieldContactIco: 'IČ (код компанії)',
    fieldContactAddress: 'Адреса',
    footerHeader: 'Підвал форми гостя',
    footerDesc: 'Виберіть, який контакт відображається в кінці форми check-in гостя.',
    fieldFooterType: 'Показати в підвалі форми гостя',
    footerTypeManager: 'Як вказано вище',
    footerTypeContact: 'Інший контакт',
    footerContactFullName: 'Інший контакт - Повне ім\'я',
    footerContactEmail: 'Інший контакт - Email',
    footerContactPhone: 'Інший контакт - Телефон',
    guideIntroTitle: 'Що таке путівник для заселення?',
    guideIntroDesc: 'Персоналізована веб-сторінка, автоматично надіслана вашим гостям — містить усе необхідне для комфортного заїзду.',
    guideIntroStep1Label: 'Заповніть інформацію',
    guideIntroStep1Desc: 'Додайте адресу, WiFi, доступ до ключа, паркування, фото та будь-які інструкції.',
    guideIntroStep2Label: 'Гість отримує посилання',
    guideIntroStep2Desc: 'Після того як гість надішле реєстраційну форму, він автоматично отримає посилання на путівник електронною поштою.',
    guideIntroStep3Label: 'Гість бачить путівник',
    guideIntroStep3Desc: 'Персональний цифровий путівник з інформацією про апартамент — доступний у будь-який час на телефоні.',
    guideSectionSettings: 'Налаштування путівника',
    guideEnable: 'Увімкнути путівник check-in для цього апартаменту',
    guideVisibleSections: 'Видимі секції',
    guideSecAddress: '📍 Адреса',
    guideSecKeyAccess: '🔑 Доступ ключем',
    guideSecWifi: '📶 WiFi',
    guideSecParking: '🚗 Паркування',
    guideSecHostContact: '📞 Контакт господаря',
    guideSecDetailedGuide: '📖 Детальний путівник',
    guideSecPhotos: '🖼️ Фото',
    guideSecOtherLinks: '🔗 Інші посилання',
    guideSecAttentionNotes: '⚠️ Зверніть увагу',
    guideSecCheckoutInstructions: '🚪 Інструкції з виїзду',
    guideSecWeather: '🌤️ Погода',
    guideSectionLocation: 'Check-in та розташування',
    guideFieldCheckinTime: 'Час заїзду',
    guideFieldCheckoutTime: 'Час виїзду',
    guideFieldAddress: 'Адреса',
    guideFieldAddressRemark: 'Примітка до адреси',
    guideAddressRemarkPlaceholder: 'наприклад: 3-й поверх, дзвінок №12, код воріт 1234',
    guideSectionKeyAccess: 'Доступ ключем',
    guideFieldAccessType: 'Тип доступу',
    guideAccessTypeSelect: '— Оберіть —',
    guideAccessTypeDoorCode: 'Код дверей',
    guideAccessTypeKeybox: 'Ключниця',
    guideAccessTypePerson: 'Особисто / Від господаря',
    guideAccessTypeNoKey: 'Ключ не потрібен',
    guideAccessTypeTtlock: '🔐 Розумний замок (TTLock)',
    guideFieldSmartLock: 'Розумний замок',
    guideSelectLock: '— Оберіть замок —',
    guideFieldOfflineFallback: 'Автоматично використовувати офлайн-код при помилці',
    guideOfflineFallbackHint: 'Якщо генерація PIN не вдається (наприклад, замок не підключений до шлюзу), система автоматично отримає хмарний офлайн-код, який працює навіть без підключення замка.',
    guideFieldKeyCode: 'Код ключа',
    guideKeyCodePlaceholder: 'Код дверей/ключниці',
    guidePinVisibleFrom: 'PIN видно від',
    guideCodeVisibleFrom: 'Код видно від',
    guideVisibilityAlways: 'Завжди видно',
    guideVisibilityFrom: 'Видно від:',
    guidePinHiddenUntil: (time) => `PIN буде прихований до ${time} в день заїзду.`,
    guideCodeHiddenUntil: (time) => `Код буде прихований до ${time} в день заїзду.`,
    guideFieldKeyRemark: 'Примітка до ключа',
    guideKeyRemarkPlaceholder: 'Додаткові інструкції щодо ключа/входу',
    guideSectionAmenities: 'Зручності',
    guideFieldWifiName: 'Назва мережі WiFi',
    guideFieldWifiPassword: 'Пароль WiFi',
    guideFieldParkingInfo: 'Інформація про паркування',
    guideParkingPlaceholder: 'Місце паркування, інструкції',
    guideFieldParkingPrice: 'Ціна паркування',
    guideParkingPricePlaceholder: 'наприклад: Безкоштовно, 100 CZK/день',
    guideSectionHostContact: 'Контакт господаря',
    guideHostName: 'Ім\'я',
    guideHostPhone: 'Телефон',
    guideHostEmail: 'Email',
    guideSectionGuestInstructions: 'Інструкції для гостей',
    guideDetailedGuidePlaceholder: 'Правила проживання, інструкції до приладів, сортування сміття, екстрені контакти…',
    guideAttentionPlaceholder: 'Важливі попередження, які гості не повинні пропустити (наприклад: не грюкайте дверима, не курити, тихий час…)',
    guideCheckoutPlaceholder: 'Кроки для виїзду (наприклад: залиште ключі в ящику, винесіть сміття, закрийте вікна…)',
    guideEnglishVersionAdd: '+ Додати англійську версію',
    guideEnglishVersionLabel: 'Англійська версія (необов\'язково)',
    guideEnglishVersionClear: 'Очистити',
    guideSectionOtherLinks: 'Інші посилання',
    guideLinkLabelPlaceholder: 'Назва (наприклад: YouTube)',
    guideLinkUrlPlaceholder: 'URL',
    guideAddLink: '+ Додати посилання',
    guideSaving: 'Збереження…',
    guideSave: 'Зберегти путівник',
    guideSavedSuccess: 'Путівник check-in збережено.',
    guideSectionPhotos: 'Фото',
    guidePhotosDesc: 'Завантажте фото, які гості побачать у путівнику check-in (наприклад: вхід, ключниця, паркування). Макс 10 фото, 10 МБ кожне. Фото зберігаються одразу.',
    guidePhotoCaption: 'Підпис (необов\'язково)',
    guidePhotoCaptionPlaceholder: 'наприклад: Ключниця праворуч від дверей',
    guidePhotoUploading: (pct) => `Завантажую… ${pct}%`,
    guidePhotoAdd: '+ Додати фото',
    guidePhotoFileHint: (used) => `JPEG, PNG, WebP, HEIC · макс 10 МБ · ${used}/10 використано`,
    guidePhotoMaxReached: 'Досягнуто максимум 10 фото. Видаліть фото, щоб завантажити нове.',
    guidePhotoConfirmDelete: 'Видалити це фото?',
    exportHeader: 'Експорт бронювань',
    exportDesc: 'Експортуйте всі бронювання та дані зареєстрованих гостей за вибраний період (за датою заїзду). CSV містить всі поля без підписів. PDF містить компактну таблицю з підписами.',
    exportLabelFrom: 'Від',
    exportLabelTo: 'До',
    exportCsvLoading: 'Підготовка CSV…',
    exportCsv: '⬇ Експорт CSV',
    exportPdfLoading: 'Генерація PDF…',
    exportPdf: '⬇ Експорт PDF',
    exportCsvDesc: 'Один рядок на гостя, всі поля, без підпису. Підходить для таблиць.',
    exportCsvBadge: 'Таблиця',
    exportPdfDesc: 'Компактна альбомна таблиця з невеликими вбудованими підписами, оптимізована для мінімуму сторінок.',
    exportPdfBadge: 'З підписами',
    deleteModalHeader: 'Видалити апартамент',
    deleteModalDescPre: 'Це назавжди видалить',
    deleteModalDescPost: 'та всі пов\'язані дані.',
    deleteModalWillDelete: 'Наступне буде видалено назавжди:',
    deleteModalReservations: (count) => `${count} бронювання${count === 1 ? '' : 'й'}`,
    deleteModalUbyportSubmitted: (count) => `(${count} надіслано в Ubyport)`,
    deleteModalDorucenka: (count) => `${count} PDF-квитанці${count === 1 ? 'я' : 'ї'} Doručenka — ваш доказ відповідності Ubyport. Експортуйте їх перед продовженням.`,
    deleteModalCalendars: (count) => `${count} підключений${count === 1 ? '' : 'х'} календар${count === 1 ? '' : 'ів'}`,
    deleteModalTypeToConfirm: 'Введіть назву апартаменту для підтвердження:',
    cancel: 'Скасувати',
    deleting: 'Видалення…',
    deleteConfirm: 'Видалити назавжди',
  },
};
